/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as GitlabCallbackRouteImport } from './routes/gitlab-callback/route'
import { Route as GithubCallbackRouteImport } from './routes/github-callback/route'
import { Route as RootRouteImport } from './routes/_root/route'
import { Route as RootIndexImport } from './routes/_root/index'
import { Route as GitlabCallbackInstalledImport } from './routes/gitlab-callback/installed'
import { Route as GitlabCallbackAuthenticatedImport } from './routes/gitlab-callback/authenticated'
import { Route as GithubCallbackInstalledImport } from './routes/github-callback/installed'
import { Route as GithubCallbackAuthenticatedImport } from './routes/github-callback/authenticated'
import { Route as RootRcaDemoRouteImport } from './routes/_root/rca-demo/route'
import { Route as RootRcaRouteImport } from './routes/_root/rca/route'
import { Route as RootIntegrationsRouteImport } from './routes/_root/integrations/route'
import { Route as RootCoverageRouteImport } from './routes/_root/coverage/route'
import { Route as RootConfigurationRouteImport } from './routes/_root/configuration/route'
import { Route as RootCatalogRouteImport } from './routes/_root/catalog/route'
import { Route as RootAdminRouteImport } from './routes/_root/admin/route'
import { Route as RootSearchIndexImport } from './routes/_root/search/index'
import { Route as RootRcaIndexImport } from './routes/_root/rca/index'
import { Route as RootRcaDemoIndexImport } from './routes/_root/rca-demo/index'
import { Route as RootPullRequestIndexImport } from './routes/_root/pull-request/index'
import { Route as RootNewProjectIndexImport } from './routes/_root/new-project/index'
import { Route as RootMyProfileIndexImport } from './routes/_root/my-profile/index'
import { Route as RootIntegrationsIndexImport } from './routes/_root/integrations/index'
import { Route as RootGettingStartedIndexImport } from './routes/_root/getting-started/index'
import { Route as RootCoverageIndexImport } from './routes/_root/coverage/index'
import { Route as RootConfigurationIndexImport } from './routes/_root/configuration/index'
import { Route as RootCatalogIndexImport } from './routes/_root/catalog/index'
import { Route as RootAdminIndexImport } from './routes/_root/admin/index'
import { Route as authSlackNotLinkedIndexImport } from './routes/(auth)/slack-not-linked/index'
import { Route as authSignUpIndexImport } from './routes/(auth)/sign-up/index'
import { Route as authSignInIndexImport } from './routes/(auth)/sign-in/index'
import { Route as authResetPasswordIndexImport } from './routes/(auth)/reset-password/index'
import { Route as authResetPasswordOnInvitationIndexImport } from './routes/(auth)/reset-password-on-invitation/index'
import { Route as authNotVerifiedIndexImport } from './routes/(auth)/not-verified/index'
import { Route as authForgotPasswordIndexImport } from './routes/(auth)/forgot-password/index'
import { Route as RootResourceResourceIdImport } from './routes/_root/resource/$resourceId'
import { Route as RootGettingStartedSlackChannelsImport } from './routes/_root/getting-started/slack-channels'
import { Route as RootIntegrationsGcpRouteImport } from './routes/_root/integrations/gcp/route'
import { Route as RootIntegrationsAwsRouteImport } from './routes/_root/integrations/aws/route'
import { Route as RootRcaIncidentIdIndexImport } from './routes/_root/rca/$incidentId/index'
import { Route as RootRcaDemoIncidentIdIndexImport } from './routes/_root/rca-demo/$incidentId/index'
import { Route as RootIntegrationsGitlabIndexImport } from './routes/_root/integrations/gitlab/index'
import { Route as RootIntegrationsGcpIndexImport } from './routes/_root/integrations/gcp/index'
import { Route as RootIntegrationsAwsIndexImport } from './routes/_root/integrations/aws/index'
import { Route as RootIntegrationsTerraformBackendHcpCloudRouteImport } from './routes/_root/integrations/terraform-backend/hcp-cloud/route'
import { Route as RootIntegrationsTerraformBackendBucketsRouteImport } from './routes/_root/integrations/terraform-backend/buckets/route'
import { Route as RootIntegrationsMonitoringGrafanaRouteImport } from './routes/_root/integrations/monitoring/grafana/route'
import { Route as RootIntegrationsMonitoringDatadogApiCredentialsRouteImport } from './routes/_root/integrations/monitoring/datadog-api-credentials/route'
import { Route as RootIntegrationsMessagingSlackRouteImport } from './routes/_root/integrations/messaging/slack/route'
import { Route as RootIntegrationsIncidentsManagementPagerdutyRouteImport } from './routes/_root/integrations/incidents-management/pagerduty/route'
import { Route as RootIntegrationsGcpServiceAccountsRouteImport } from './routes/_root/integrations/gcp/service-accounts/route'
import { Route as RootIntegrationsContainersKubernetesRouteImport } from './routes/_root/integrations/containers/kubernetes/route'
import { Route as RootIntegrationsTerraformBackendHcpCloudIndexImport } from './routes/_root/integrations/terraform-backend/hcp-cloud/index'
import { Route as RootIntegrationsTerraformBackendBucketsIndexImport } from './routes/_root/integrations/terraform-backend/buckets/index'
import { Route as RootIntegrationsMonitoringGrafanaIndexImport } from './routes/_root/integrations/monitoring/grafana/index'
import { Route as RootIntegrationsMonitoringDatadogApiCredentialsIndexImport } from './routes/_root/integrations/monitoring/datadog-api-credentials/index'
import { Route as RootIntegrationsMessagingSlackIndexImport } from './routes/_root/integrations/messaging/slack/index'
import { Route as RootIntegrationsIncidentsManagementPagerdutyIndexImport } from './routes/_root/integrations/incidents-management/pagerduty/index'
import { Route as RootIntegrationsGcpServiceAccountsIndexImport } from './routes/_root/integrations/gcp/service-accounts/index'
import { Route as RootIntegrationsContainersKubernetesIndexImport } from './routes/_root/integrations/containers/kubernetes/index'
import { Route as RootIntegrationsTerraformBackendHcpCloudNewImport } from './routes/_root/integrations/terraform-backend/hcp-cloud/new'
import { Route as RootIntegrationsTerraformBackendHcpCloudTokenIdImport } from './routes/_root/integrations/terraform-backend/hcp-cloud/$tokenId'
import { Route as RootIntegrationsMonitoringGrafanaNewImport } from './routes/_root/integrations/monitoring/grafana/new'
import { Route as RootIntegrationsMonitoringGrafanaIdImport } from './routes/_root/integrations/monitoring/grafana/$id'
import { Route as RootIntegrationsMonitoringDatadogApiCredentialsNewImport } from './routes/_root/integrations/monitoring/datadog-api-credentials/new'
import { Route as RootIntegrationsMonitoringDatadogApiCredentialsIdImport } from './routes/_root/integrations/monitoring/datadog-api-credentials/$id'
import { Route as RootIntegrationsGcpServiceAccountsNewImport } from './routes/_root/integrations/gcp/service-accounts/new'
import { Route as RootIntegrationsGcpServiceAccountsAccountIdImport } from './routes/_root/integrations/gcp/service-accounts/$accountId'
import { Route as RootIntegrationsAwsUsersNewImport } from './routes/_root/integrations/aws/users/new'
import { Route as RootIntegrationsAwsUsersUserIdImport } from './routes/_root/integrations/aws/users/$userId'
import { Route as RootIntegrationsAwsRolesNewImport } from './routes/_root/integrations/aws/roles/new'
import { Route as RootIntegrationsAwsRolesRoleIdImport } from './routes/_root/integrations/aws/roles/$roleId'
import { Route as RootIntegrationsIncidentsManagementPagerdutyWebhooksNewImport } from './routes/_root/integrations/incidents-management/pagerduty/webhooks/new'
import { Route as RootIntegrationsIncidentsManagementPagerdutyWebhooksWebhookIdImport } from './routes/_root/integrations/incidents-management/pagerduty/webhooks/$webhookId'
import { Route as RootIntegrationsIncidentsManagementPagerdutyTokensNewImport } from './routes/_root/integrations/incidents-management/pagerduty/tokens/new'
import { Route as RootIntegrationsIncidentsManagementPagerdutyTokensTokenIdImport } from './routes/_root/integrations/incidents-management/pagerduty/tokens/$tokenId'

// Create/Update Routes

const GitlabCallbackRouteRoute = GitlabCallbackRouteImport.update({
  id: '/gitlab-callback',
  path: '/gitlab-callback',
  getParentRoute: () => rootRoute,
} as any)

const GithubCallbackRouteRoute = GithubCallbackRouteImport.update({
  id: '/github-callback',
  path: '/github-callback',
  getParentRoute: () => rootRoute,
} as any)

const RootRouteRoute = RootRouteImport.update({
  id: '/_root',
  getParentRoute: () => rootRoute,
} as any)

const RootIndexRoute = RootIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RootRouteRoute,
} as any)

const GitlabCallbackInstalledRoute = GitlabCallbackInstalledImport.update({
  id: '/installed',
  path: '/installed',
  getParentRoute: () => GitlabCallbackRouteRoute,
} as any)

const GitlabCallbackAuthenticatedRoute =
  GitlabCallbackAuthenticatedImport.update({
    id: '/authenticated',
    path: '/authenticated',
    getParentRoute: () => GitlabCallbackRouteRoute,
  } as any)

const GithubCallbackInstalledRoute = GithubCallbackInstalledImport.update({
  id: '/installed',
  path: '/installed',
  getParentRoute: () => GithubCallbackRouteRoute,
} as any)

const GithubCallbackAuthenticatedRoute =
  GithubCallbackAuthenticatedImport.update({
    id: '/authenticated',
    path: '/authenticated',
    getParentRoute: () => GithubCallbackRouteRoute,
  } as any)

const RootRcaDemoRouteRoute = RootRcaDemoRouteImport.update({
  id: '/rca-demo',
  path: '/rca-demo',
  getParentRoute: () => RootRouteRoute,
} as any)

const RootRcaRouteRoute = RootRcaRouteImport.update({
  id: '/rca',
  path: '/rca',
  getParentRoute: () => RootRouteRoute,
} as any)

const RootIntegrationsRouteRoute = RootIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => RootRouteRoute,
} as any)

const RootCoverageRouteRoute = RootCoverageRouteImport.update({
  id: '/coverage',
  path: '/coverage',
  getParentRoute: () => RootRouteRoute,
} as any)

const RootConfigurationRouteRoute = RootConfigurationRouteImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => RootRouteRoute,
} as any)

const RootCatalogRouteRoute = RootCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => RootRouteRoute,
} as any)

const RootAdminRouteRoute = RootAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => RootRouteRoute,
} as any)

const RootSearchIndexRoute = RootSearchIndexImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => RootRouteRoute,
} as any)

const RootRcaIndexRoute = RootRcaIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RootRcaRouteRoute,
} as any)

const RootRcaDemoIndexRoute = RootRcaDemoIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RootRcaDemoRouteRoute,
} as any)

const RootPullRequestIndexRoute = RootPullRequestIndexImport.update({
  id: '/pull-request/',
  path: '/pull-request/',
  getParentRoute: () => RootRouteRoute,
} as any)

const RootNewProjectIndexRoute = RootNewProjectIndexImport.update({
  id: '/new-project/',
  path: '/new-project/',
  getParentRoute: () => RootRouteRoute,
} as any)

const RootMyProfileIndexRoute = RootMyProfileIndexImport.update({
  id: '/my-profile/',
  path: '/my-profile/',
  getParentRoute: () => RootRouteRoute,
} as any)

const RootIntegrationsIndexRoute = RootIntegrationsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RootIntegrationsRouteRoute,
} as any)

const RootGettingStartedIndexRoute = RootGettingStartedIndexImport.update({
  id: '/getting-started/',
  path: '/getting-started/',
  getParentRoute: () => RootRouteRoute,
} as any)

const RootCoverageIndexRoute = RootCoverageIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RootCoverageRouteRoute,
} as any)

const RootConfigurationIndexRoute = RootConfigurationIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RootConfigurationRouteRoute,
} as any)

const RootCatalogIndexRoute = RootCatalogIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RootCatalogRouteRoute,
} as any)

const RootAdminIndexRoute = RootAdminIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RootAdminRouteRoute,
} as any)

const authSlackNotLinkedIndexRoute = authSlackNotLinkedIndexImport.update({
  id: '/(auth)/slack-not-linked/',
  path: '/slack-not-linked/',
  getParentRoute: () => rootRoute,
} as any)

const authSignUpIndexRoute = authSignUpIndexImport.update({
  id: '/(auth)/sign-up/',
  path: '/sign-up/',
  getParentRoute: () => rootRoute,
} as any)

const authSignInIndexRoute = authSignInIndexImport.update({
  id: '/(auth)/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => rootRoute,
} as any)

const authResetPasswordIndexRoute = authResetPasswordIndexImport.update({
  id: '/(auth)/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => rootRoute,
} as any)

const authResetPasswordOnInvitationIndexRoute =
  authResetPasswordOnInvitationIndexImport.update({
    id: '/(auth)/reset-password-on-invitation/',
    path: '/reset-password-on-invitation/',
    getParentRoute: () => rootRoute,
  } as any)

const authNotVerifiedIndexRoute = authNotVerifiedIndexImport.update({
  id: '/(auth)/not-verified/',
  path: '/not-verified/',
  getParentRoute: () => rootRoute,
} as any)

const authForgotPasswordIndexRoute = authForgotPasswordIndexImport.update({
  id: '/(auth)/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => rootRoute,
} as any)

const RootResourceResourceIdRoute = RootResourceResourceIdImport.update({
  id: '/resource/$resourceId',
  path: '/resource/$resourceId',
  getParentRoute: () => RootRouteRoute,
} as any)

const RootGettingStartedSlackChannelsRoute =
  RootGettingStartedSlackChannelsImport.update({
    id: '/getting-started/slack-channels',
    path: '/getting-started/slack-channels',
    getParentRoute: () => RootRouteRoute,
  } as any)

const RootIntegrationsGcpRouteRoute = RootIntegrationsGcpRouteImport.update({
  id: '/gcp',
  path: '/gcp',
  getParentRoute: () => RootIntegrationsRouteRoute,
} as any)

const RootIntegrationsAwsRouteRoute = RootIntegrationsAwsRouteImport.update({
  id: '/aws',
  path: '/aws',
  getParentRoute: () => RootIntegrationsRouteRoute,
} as any)

const RootRcaIncidentIdIndexRoute = RootRcaIncidentIdIndexImport.update({
  id: '/$incidentId/',
  path: '/$incidentId/',
  getParentRoute: () => RootRcaRouteRoute,
} as any)

const RootRcaDemoIncidentIdIndexRoute = RootRcaDemoIncidentIdIndexImport.update(
  {
    id: '/$incidentId/',
    path: '/$incidentId/',
    getParentRoute: () => RootRcaDemoRouteRoute,
  } as any,
)

const RootIntegrationsGitlabIndexRoute =
  RootIntegrationsGitlabIndexImport.update({
    id: '/gitlab/',
    path: '/gitlab/',
    getParentRoute: () => RootIntegrationsRouteRoute,
  } as any)

const RootIntegrationsGcpIndexRoute = RootIntegrationsGcpIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RootIntegrationsGcpRouteRoute,
} as any)

const RootIntegrationsAwsIndexRoute = RootIntegrationsAwsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RootIntegrationsAwsRouteRoute,
} as any)

const RootIntegrationsTerraformBackendHcpCloudRouteRoute =
  RootIntegrationsTerraformBackendHcpCloudRouteImport.update({
    id: '/terraform-backend/hcp-cloud',
    path: '/terraform-backend/hcp-cloud',
    getParentRoute: () => RootIntegrationsRouteRoute,
  } as any)

const RootIntegrationsTerraformBackendBucketsRouteRoute =
  RootIntegrationsTerraformBackendBucketsRouteImport.update({
    id: '/terraform-backend/buckets',
    path: '/terraform-backend/buckets',
    getParentRoute: () => RootIntegrationsRouteRoute,
  } as any)

const RootIntegrationsMonitoringGrafanaRouteRoute =
  RootIntegrationsMonitoringGrafanaRouteImport.update({
    id: '/monitoring/grafana',
    path: '/monitoring/grafana',
    getParentRoute: () => RootIntegrationsRouteRoute,
  } as any)

const RootIntegrationsMonitoringDatadogApiCredentialsRouteRoute =
  RootIntegrationsMonitoringDatadogApiCredentialsRouteImport.update({
    id: '/monitoring/datadog-api-credentials',
    path: '/monitoring/datadog-api-credentials',
    getParentRoute: () => RootIntegrationsRouteRoute,
  } as any)

const RootIntegrationsMessagingSlackRouteRoute =
  RootIntegrationsMessagingSlackRouteImport.update({
    id: '/messaging/slack',
    path: '/messaging/slack',
    getParentRoute: () => RootIntegrationsRouteRoute,
  } as any)

const RootIntegrationsIncidentsManagementPagerdutyRouteRoute =
  RootIntegrationsIncidentsManagementPagerdutyRouteImport.update({
    id: '/incidents-management/pagerduty',
    path: '/incidents-management/pagerduty',
    getParentRoute: () => RootIntegrationsRouteRoute,
  } as any)

const RootIntegrationsGcpServiceAccountsRouteRoute =
  RootIntegrationsGcpServiceAccountsRouteImport.update({
    id: '/service-accounts',
    path: '/service-accounts',
    getParentRoute: () => RootIntegrationsGcpRouteRoute,
  } as any)

const RootIntegrationsContainersKubernetesRouteRoute =
  RootIntegrationsContainersKubernetesRouteImport.update({
    id: '/containers/kubernetes',
    path: '/containers/kubernetes',
    getParentRoute: () => RootIntegrationsRouteRoute,
  } as any)

const RootIntegrationsTerraformBackendHcpCloudIndexRoute =
  RootIntegrationsTerraformBackendHcpCloudIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => RootIntegrationsTerraformBackendHcpCloudRouteRoute,
  } as any)

const RootIntegrationsTerraformBackendBucketsIndexRoute =
  RootIntegrationsTerraformBackendBucketsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => RootIntegrationsTerraformBackendBucketsRouteRoute,
  } as any)

const RootIntegrationsMonitoringGrafanaIndexRoute =
  RootIntegrationsMonitoringGrafanaIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => RootIntegrationsMonitoringGrafanaRouteRoute,
  } as any)

const RootIntegrationsMonitoringDatadogApiCredentialsIndexRoute =
  RootIntegrationsMonitoringDatadogApiCredentialsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      RootIntegrationsMonitoringDatadogApiCredentialsRouteRoute,
  } as any)

const RootIntegrationsMessagingSlackIndexRoute =
  RootIntegrationsMessagingSlackIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => RootIntegrationsMessagingSlackRouteRoute,
  } as any)

const RootIntegrationsIncidentsManagementPagerdutyIndexRoute =
  RootIntegrationsIncidentsManagementPagerdutyIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      RootIntegrationsIncidentsManagementPagerdutyRouteRoute,
  } as any)

const RootIntegrationsGcpServiceAccountsIndexRoute =
  RootIntegrationsGcpServiceAccountsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => RootIntegrationsGcpServiceAccountsRouteRoute,
  } as any)

const RootIntegrationsContainersKubernetesIndexRoute =
  RootIntegrationsContainersKubernetesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => RootIntegrationsContainersKubernetesRouteRoute,
  } as any)

const RootIntegrationsTerraformBackendHcpCloudNewRoute =
  RootIntegrationsTerraformBackendHcpCloudNewImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => RootIntegrationsTerraformBackendHcpCloudRouteRoute,
  } as any)

const RootIntegrationsTerraformBackendHcpCloudTokenIdRoute =
  RootIntegrationsTerraformBackendHcpCloudTokenIdImport.update({
    id: '/$tokenId',
    path: '/$tokenId',
    getParentRoute: () => RootIntegrationsTerraformBackendHcpCloudRouteRoute,
  } as any)

const RootIntegrationsMonitoringGrafanaNewRoute =
  RootIntegrationsMonitoringGrafanaNewImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => RootIntegrationsMonitoringGrafanaRouteRoute,
  } as any)

const RootIntegrationsMonitoringGrafanaIdRoute =
  RootIntegrationsMonitoringGrafanaIdImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => RootIntegrationsMonitoringGrafanaRouteRoute,
  } as any)

const RootIntegrationsMonitoringDatadogApiCredentialsNewRoute =
  RootIntegrationsMonitoringDatadogApiCredentialsNewImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () =>
      RootIntegrationsMonitoringDatadogApiCredentialsRouteRoute,
  } as any)

const RootIntegrationsMonitoringDatadogApiCredentialsIdRoute =
  RootIntegrationsMonitoringDatadogApiCredentialsIdImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () =>
      RootIntegrationsMonitoringDatadogApiCredentialsRouteRoute,
  } as any)

const RootIntegrationsGcpServiceAccountsNewRoute =
  RootIntegrationsGcpServiceAccountsNewImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => RootIntegrationsGcpServiceAccountsRouteRoute,
  } as any)

const RootIntegrationsGcpServiceAccountsAccountIdRoute =
  RootIntegrationsGcpServiceAccountsAccountIdImport.update({
    id: '/$accountId',
    path: '/$accountId',
    getParentRoute: () => RootIntegrationsGcpServiceAccountsRouteRoute,
  } as any)

const RootIntegrationsAwsUsersNewRoute =
  RootIntegrationsAwsUsersNewImport.update({
    id: '/users/new',
    path: '/users/new',
    getParentRoute: () => RootIntegrationsAwsRouteRoute,
  } as any)

const RootIntegrationsAwsUsersUserIdRoute =
  RootIntegrationsAwsUsersUserIdImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => RootIntegrationsAwsRouteRoute,
  } as any)

const RootIntegrationsAwsRolesNewRoute =
  RootIntegrationsAwsRolesNewImport.update({
    id: '/roles/new',
    path: '/roles/new',
    getParentRoute: () => RootIntegrationsAwsRouteRoute,
  } as any)

const RootIntegrationsAwsRolesRoleIdRoute =
  RootIntegrationsAwsRolesRoleIdImport.update({
    id: '/roles/$roleId',
    path: '/roles/$roleId',
    getParentRoute: () => RootIntegrationsAwsRouteRoute,
  } as any)

const RootIntegrationsIncidentsManagementPagerdutyWebhooksNewRoute =
  RootIntegrationsIncidentsManagementPagerdutyWebhooksNewImport.update({
    id: '/webhooks/new',
    path: '/webhooks/new',
    getParentRoute: () =>
      RootIntegrationsIncidentsManagementPagerdutyRouteRoute,
  } as any)

const RootIntegrationsIncidentsManagementPagerdutyWebhooksWebhookIdRoute =
  RootIntegrationsIncidentsManagementPagerdutyWebhooksWebhookIdImport.update({
    id: '/webhooks/$webhookId',
    path: '/webhooks/$webhookId',
    getParentRoute: () =>
      RootIntegrationsIncidentsManagementPagerdutyRouteRoute,
  } as any)

const RootIntegrationsIncidentsManagementPagerdutyTokensNewRoute =
  RootIntegrationsIncidentsManagementPagerdutyTokensNewImport.update({
    id: '/tokens/new',
    path: '/tokens/new',
    getParentRoute: () =>
      RootIntegrationsIncidentsManagementPagerdutyRouteRoute,
  } as any)

const RootIntegrationsIncidentsManagementPagerdutyTokensTokenIdRoute =
  RootIntegrationsIncidentsManagementPagerdutyTokensTokenIdImport.update({
    id: '/tokens/$tokenId',
    path: '/tokens/$tokenId',
    getParentRoute: () =>
      RootIntegrationsIncidentsManagementPagerdutyRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_root': {
      id: '/_root'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof RootRouteImport
      parentRoute: typeof rootRoute
    }
    '/github-callback': {
      id: '/github-callback'
      path: '/github-callback'
      fullPath: '/github-callback'
      preLoaderRoute: typeof GithubCallbackRouteImport
      parentRoute: typeof rootRoute
    }
    '/gitlab-callback': {
      id: '/gitlab-callback'
      path: '/gitlab-callback'
      fullPath: '/gitlab-callback'
      preLoaderRoute: typeof GitlabCallbackRouteImport
      parentRoute: typeof rootRoute
    }
    '/_root/admin': {
      id: '/_root/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof RootAdminRouteImport
      parentRoute: typeof RootRouteImport
    }
    '/_root/catalog': {
      id: '/_root/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof RootCatalogRouteImport
      parentRoute: typeof RootRouteImport
    }
    '/_root/configuration': {
      id: '/_root/configuration'
      path: '/configuration'
      fullPath: '/configuration'
      preLoaderRoute: typeof RootConfigurationRouteImport
      parentRoute: typeof RootRouteImport
    }
    '/_root/coverage': {
      id: '/_root/coverage'
      path: '/coverage'
      fullPath: '/coverage'
      preLoaderRoute: typeof RootCoverageRouteImport
      parentRoute: typeof RootRouteImport
    }
    '/_root/integrations': {
      id: '/_root/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof RootIntegrationsRouteImport
      parentRoute: typeof RootRouteImport
    }
    '/_root/rca': {
      id: '/_root/rca'
      path: '/rca'
      fullPath: '/rca'
      preLoaderRoute: typeof RootRcaRouteImport
      parentRoute: typeof RootRouteImport
    }
    '/_root/rca-demo': {
      id: '/_root/rca-demo'
      path: '/rca-demo'
      fullPath: '/rca-demo'
      preLoaderRoute: typeof RootRcaDemoRouteImport
      parentRoute: typeof RootRouteImport
    }
    '/github-callback/authenticated': {
      id: '/github-callback/authenticated'
      path: '/authenticated'
      fullPath: '/github-callback/authenticated'
      preLoaderRoute: typeof GithubCallbackAuthenticatedImport
      parentRoute: typeof GithubCallbackRouteImport
    }
    '/github-callback/installed': {
      id: '/github-callback/installed'
      path: '/installed'
      fullPath: '/github-callback/installed'
      preLoaderRoute: typeof GithubCallbackInstalledImport
      parentRoute: typeof GithubCallbackRouteImport
    }
    '/gitlab-callback/authenticated': {
      id: '/gitlab-callback/authenticated'
      path: '/authenticated'
      fullPath: '/gitlab-callback/authenticated'
      preLoaderRoute: typeof GitlabCallbackAuthenticatedImport
      parentRoute: typeof GitlabCallbackRouteImport
    }
    '/gitlab-callback/installed': {
      id: '/gitlab-callback/installed'
      path: '/installed'
      fullPath: '/gitlab-callback/installed'
      preLoaderRoute: typeof GitlabCallbackInstalledImport
      parentRoute: typeof GitlabCallbackRouteImport
    }
    '/_root/': {
      id: '/_root/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof RootIndexImport
      parentRoute: typeof RootRouteImport
    }
    '/_root/integrations/aws': {
      id: '/_root/integrations/aws'
      path: '/aws'
      fullPath: '/integrations/aws'
      preLoaderRoute: typeof RootIntegrationsAwsRouteImport
      parentRoute: typeof RootIntegrationsRouteImport
    }
    '/_root/integrations/gcp': {
      id: '/_root/integrations/gcp'
      path: '/gcp'
      fullPath: '/integrations/gcp'
      preLoaderRoute: typeof RootIntegrationsGcpRouteImport
      parentRoute: typeof RootIntegrationsRouteImport
    }
    '/_root/getting-started/slack-channels': {
      id: '/_root/getting-started/slack-channels'
      path: '/getting-started/slack-channels'
      fullPath: '/getting-started/slack-channels'
      preLoaderRoute: typeof RootGettingStartedSlackChannelsImport
      parentRoute: typeof RootRouteImport
    }
    '/_root/resource/$resourceId': {
      id: '/_root/resource/$resourceId'
      path: '/resource/$resourceId'
      fullPath: '/resource/$resourceId'
      preLoaderRoute: typeof RootResourceResourceIdImport
      parentRoute: typeof RootRouteImport
    }
    '/(auth)/forgot-password/': {
      id: '/(auth)/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordIndexImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/not-verified/': {
      id: '/(auth)/not-verified/'
      path: '/not-verified'
      fullPath: '/not-verified'
      preLoaderRoute: typeof authNotVerifiedIndexImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/reset-password-on-invitation/': {
      id: '/(auth)/reset-password-on-invitation/'
      path: '/reset-password-on-invitation'
      fullPath: '/reset-password-on-invitation'
      preLoaderRoute: typeof authResetPasswordOnInvitationIndexImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/reset-password/': {
      id: '/(auth)/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordIndexImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-in/': {
      id: '/(auth)/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInIndexImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-up/': {
      id: '/(auth)/sign-up/'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpIndexImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/slack-not-linked/': {
      id: '/(auth)/slack-not-linked/'
      path: '/slack-not-linked'
      fullPath: '/slack-not-linked'
      preLoaderRoute: typeof authSlackNotLinkedIndexImport
      parentRoute: typeof rootRoute
    }
    '/_root/admin/': {
      id: '/_root/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof RootAdminIndexImport
      parentRoute: typeof RootAdminRouteImport
    }
    '/_root/catalog/': {
      id: '/_root/catalog/'
      path: '/'
      fullPath: '/catalog/'
      preLoaderRoute: typeof RootCatalogIndexImport
      parentRoute: typeof RootCatalogRouteImport
    }
    '/_root/configuration/': {
      id: '/_root/configuration/'
      path: '/'
      fullPath: '/configuration/'
      preLoaderRoute: typeof RootConfigurationIndexImport
      parentRoute: typeof RootConfigurationRouteImport
    }
    '/_root/coverage/': {
      id: '/_root/coverage/'
      path: '/'
      fullPath: '/coverage/'
      preLoaderRoute: typeof RootCoverageIndexImport
      parentRoute: typeof RootCoverageRouteImport
    }
    '/_root/getting-started/': {
      id: '/_root/getting-started/'
      path: '/getting-started'
      fullPath: '/getting-started'
      preLoaderRoute: typeof RootGettingStartedIndexImport
      parentRoute: typeof RootRouteImport
    }
    '/_root/integrations/': {
      id: '/_root/integrations/'
      path: '/'
      fullPath: '/integrations/'
      preLoaderRoute: typeof RootIntegrationsIndexImport
      parentRoute: typeof RootIntegrationsRouteImport
    }
    '/_root/my-profile/': {
      id: '/_root/my-profile/'
      path: '/my-profile'
      fullPath: '/my-profile'
      preLoaderRoute: typeof RootMyProfileIndexImport
      parentRoute: typeof RootRouteImport
    }
    '/_root/new-project/': {
      id: '/_root/new-project/'
      path: '/new-project'
      fullPath: '/new-project'
      preLoaderRoute: typeof RootNewProjectIndexImport
      parentRoute: typeof RootRouteImport
    }
    '/_root/pull-request/': {
      id: '/_root/pull-request/'
      path: '/pull-request'
      fullPath: '/pull-request'
      preLoaderRoute: typeof RootPullRequestIndexImport
      parentRoute: typeof RootRouteImport
    }
    '/_root/rca-demo/': {
      id: '/_root/rca-demo/'
      path: '/'
      fullPath: '/rca-demo/'
      preLoaderRoute: typeof RootRcaDemoIndexImport
      parentRoute: typeof RootRcaDemoRouteImport
    }
    '/_root/rca/': {
      id: '/_root/rca/'
      path: '/'
      fullPath: '/rca/'
      preLoaderRoute: typeof RootRcaIndexImport
      parentRoute: typeof RootRcaRouteImport
    }
    '/_root/search/': {
      id: '/_root/search/'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof RootSearchIndexImport
      parentRoute: typeof RootRouteImport
    }
    '/_root/integrations/containers/kubernetes': {
      id: '/_root/integrations/containers/kubernetes'
      path: '/containers/kubernetes'
      fullPath: '/integrations/containers/kubernetes'
      preLoaderRoute: typeof RootIntegrationsContainersKubernetesRouteImport
      parentRoute: typeof RootIntegrationsRouteImport
    }
    '/_root/integrations/gcp/service-accounts': {
      id: '/_root/integrations/gcp/service-accounts'
      path: '/service-accounts'
      fullPath: '/integrations/gcp/service-accounts'
      preLoaderRoute: typeof RootIntegrationsGcpServiceAccountsRouteImport
      parentRoute: typeof RootIntegrationsGcpRouteImport
    }
    '/_root/integrations/incidents-management/pagerduty': {
      id: '/_root/integrations/incidents-management/pagerduty'
      path: '/incidents-management/pagerduty'
      fullPath: '/integrations/incidents-management/pagerduty'
      preLoaderRoute: typeof RootIntegrationsIncidentsManagementPagerdutyRouteImport
      parentRoute: typeof RootIntegrationsRouteImport
    }
    '/_root/integrations/messaging/slack': {
      id: '/_root/integrations/messaging/slack'
      path: '/messaging/slack'
      fullPath: '/integrations/messaging/slack'
      preLoaderRoute: typeof RootIntegrationsMessagingSlackRouteImport
      parentRoute: typeof RootIntegrationsRouteImport
    }
    '/_root/integrations/monitoring/datadog-api-credentials': {
      id: '/_root/integrations/monitoring/datadog-api-credentials'
      path: '/monitoring/datadog-api-credentials'
      fullPath: '/integrations/monitoring/datadog-api-credentials'
      preLoaderRoute: typeof RootIntegrationsMonitoringDatadogApiCredentialsRouteImport
      parentRoute: typeof RootIntegrationsRouteImport
    }
    '/_root/integrations/monitoring/grafana': {
      id: '/_root/integrations/monitoring/grafana'
      path: '/monitoring/grafana'
      fullPath: '/integrations/monitoring/grafana'
      preLoaderRoute: typeof RootIntegrationsMonitoringGrafanaRouteImport
      parentRoute: typeof RootIntegrationsRouteImport
    }
    '/_root/integrations/terraform-backend/buckets': {
      id: '/_root/integrations/terraform-backend/buckets'
      path: '/terraform-backend/buckets'
      fullPath: '/integrations/terraform-backend/buckets'
      preLoaderRoute: typeof RootIntegrationsTerraformBackendBucketsRouteImport
      parentRoute: typeof RootIntegrationsRouteImport
    }
    '/_root/integrations/terraform-backend/hcp-cloud': {
      id: '/_root/integrations/terraform-backend/hcp-cloud'
      path: '/terraform-backend/hcp-cloud'
      fullPath: '/integrations/terraform-backend/hcp-cloud'
      preLoaderRoute: typeof RootIntegrationsTerraformBackendHcpCloudRouteImport
      parentRoute: typeof RootIntegrationsRouteImport
    }
    '/_root/integrations/aws/': {
      id: '/_root/integrations/aws/'
      path: '/'
      fullPath: '/integrations/aws/'
      preLoaderRoute: typeof RootIntegrationsAwsIndexImport
      parentRoute: typeof RootIntegrationsAwsRouteImport
    }
    '/_root/integrations/gcp/': {
      id: '/_root/integrations/gcp/'
      path: '/'
      fullPath: '/integrations/gcp/'
      preLoaderRoute: typeof RootIntegrationsGcpIndexImport
      parentRoute: typeof RootIntegrationsGcpRouteImport
    }
    '/_root/integrations/gitlab/': {
      id: '/_root/integrations/gitlab/'
      path: '/gitlab'
      fullPath: '/integrations/gitlab'
      preLoaderRoute: typeof RootIntegrationsGitlabIndexImport
      parentRoute: typeof RootIntegrationsRouteImport
    }
    '/_root/rca-demo/$incidentId/': {
      id: '/_root/rca-demo/$incidentId/'
      path: '/$incidentId'
      fullPath: '/rca-demo/$incidentId'
      preLoaderRoute: typeof RootRcaDemoIncidentIdIndexImport
      parentRoute: typeof RootRcaDemoRouteImport
    }
    '/_root/rca/$incidentId/': {
      id: '/_root/rca/$incidentId/'
      path: '/$incidentId'
      fullPath: '/rca/$incidentId'
      preLoaderRoute: typeof RootRcaIncidentIdIndexImport
      parentRoute: typeof RootRcaRouteImport
    }
    '/_root/integrations/aws/roles/$roleId': {
      id: '/_root/integrations/aws/roles/$roleId'
      path: '/roles/$roleId'
      fullPath: '/integrations/aws/roles/$roleId'
      preLoaderRoute: typeof RootIntegrationsAwsRolesRoleIdImport
      parentRoute: typeof RootIntegrationsAwsRouteImport
    }
    '/_root/integrations/aws/roles/new': {
      id: '/_root/integrations/aws/roles/new'
      path: '/roles/new'
      fullPath: '/integrations/aws/roles/new'
      preLoaderRoute: typeof RootIntegrationsAwsRolesNewImport
      parentRoute: typeof RootIntegrationsAwsRouteImport
    }
    '/_root/integrations/aws/users/$userId': {
      id: '/_root/integrations/aws/users/$userId'
      path: '/users/$userId'
      fullPath: '/integrations/aws/users/$userId'
      preLoaderRoute: typeof RootIntegrationsAwsUsersUserIdImport
      parentRoute: typeof RootIntegrationsAwsRouteImport
    }
    '/_root/integrations/aws/users/new': {
      id: '/_root/integrations/aws/users/new'
      path: '/users/new'
      fullPath: '/integrations/aws/users/new'
      preLoaderRoute: typeof RootIntegrationsAwsUsersNewImport
      parentRoute: typeof RootIntegrationsAwsRouteImport
    }
    '/_root/integrations/gcp/service-accounts/$accountId': {
      id: '/_root/integrations/gcp/service-accounts/$accountId'
      path: '/$accountId'
      fullPath: '/integrations/gcp/service-accounts/$accountId'
      preLoaderRoute: typeof RootIntegrationsGcpServiceAccountsAccountIdImport
      parentRoute: typeof RootIntegrationsGcpServiceAccountsRouteImport
    }
    '/_root/integrations/gcp/service-accounts/new': {
      id: '/_root/integrations/gcp/service-accounts/new'
      path: '/new'
      fullPath: '/integrations/gcp/service-accounts/new'
      preLoaderRoute: typeof RootIntegrationsGcpServiceAccountsNewImport
      parentRoute: typeof RootIntegrationsGcpServiceAccountsRouteImport
    }
    '/_root/integrations/monitoring/datadog-api-credentials/$id': {
      id: '/_root/integrations/monitoring/datadog-api-credentials/$id'
      path: '/$id'
      fullPath: '/integrations/monitoring/datadog-api-credentials/$id'
      preLoaderRoute: typeof RootIntegrationsMonitoringDatadogApiCredentialsIdImport
      parentRoute: typeof RootIntegrationsMonitoringDatadogApiCredentialsRouteImport
    }
    '/_root/integrations/monitoring/datadog-api-credentials/new': {
      id: '/_root/integrations/monitoring/datadog-api-credentials/new'
      path: '/new'
      fullPath: '/integrations/monitoring/datadog-api-credentials/new'
      preLoaderRoute: typeof RootIntegrationsMonitoringDatadogApiCredentialsNewImport
      parentRoute: typeof RootIntegrationsMonitoringDatadogApiCredentialsRouteImport
    }
    '/_root/integrations/monitoring/grafana/$id': {
      id: '/_root/integrations/monitoring/grafana/$id'
      path: '/$id'
      fullPath: '/integrations/monitoring/grafana/$id'
      preLoaderRoute: typeof RootIntegrationsMonitoringGrafanaIdImport
      parentRoute: typeof RootIntegrationsMonitoringGrafanaRouteImport
    }
    '/_root/integrations/monitoring/grafana/new': {
      id: '/_root/integrations/monitoring/grafana/new'
      path: '/new'
      fullPath: '/integrations/monitoring/grafana/new'
      preLoaderRoute: typeof RootIntegrationsMonitoringGrafanaNewImport
      parentRoute: typeof RootIntegrationsMonitoringGrafanaRouteImport
    }
    '/_root/integrations/terraform-backend/hcp-cloud/$tokenId': {
      id: '/_root/integrations/terraform-backend/hcp-cloud/$tokenId'
      path: '/$tokenId'
      fullPath: '/integrations/terraform-backend/hcp-cloud/$tokenId'
      preLoaderRoute: typeof RootIntegrationsTerraformBackendHcpCloudTokenIdImport
      parentRoute: typeof RootIntegrationsTerraformBackendHcpCloudRouteImport
    }
    '/_root/integrations/terraform-backend/hcp-cloud/new': {
      id: '/_root/integrations/terraform-backend/hcp-cloud/new'
      path: '/new'
      fullPath: '/integrations/terraform-backend/hcp-cloud/new'
      preLoaderRoute: typeof RootIntegrationsTerraformBackendHcpCloudNewImport
      parentRoute: typeof RootIntegrationsTerraformBackendHcpCloudRouteImport
    }
    '/_root/integrations/containers/kubernetes/': {
      id: '/_root/integrations/containers/kubernetes/'
      path: '/'
      fullPath: '/integrations/containers/kubernetes/'
      preLoaderRoute: typeof RootIntegrationsContainersKubernetesIndexImport
      parentRoute: typeof RootIntegrationsContainersKubernetesRouteImport
    }
    '/_root/integrations/gcp/service-accounts/': {
      id: '/_root/integrations/gcp/service-accounts/'
      path: '/'
      fullPath: '/integrations/gcp/service-accounts/'
      preLoaderRoute: typeof RootIntegrationsGcpServiceAccountsIndexImport
      parentRoute: typeof RootIntegrationsGcpServiceAccountsRouteImport
    }
    '/_root/integrations/incidents-management/pagerduty/': {
      id: '/_root/integrations/incidents-management/pagerduty/'
      path: '/'
      fullPath: '/integrations/incidents-management/pagerduty/'
      preLoaderRoute: typeof RootIntegrationsIncidentsManagementPagerdutyIndexImport
      parentRoute: typeof RootIntegrationsIncidentsManagementPagerdutyRouteImport
    }
    '/_root/integrations/messaging/slack/': {
      id: '/_root/integrations/messaging/slack/'
      path: '/'
      fullPath: '/integrations/messaging/slack/'
      preLoaderRoute: typeof RootIntegrationsMessagingSlackIndexImport
      parentRoute: typeof RootIntegrationsMessagingSlackRouteImport
    }
    '/_root/integrations/monitoring/datadog-api-credentials/': {
      id: '/_root/integrations/monitoring/datadog-api-credentials/'
      path: '/'
      fullPath: '/integrations/monitoring/datadog-api-credentials/'
      preLoaderRoute: typeof RootIntegrationsMonitoringDatadogApiCredentialsIndexImport
      parentRoute: typeof RootIntegrationsMonitoringDatadogApiCredentialsRouteImport
    }
    '/_root/integrations/monitoring/grafana/': {
      id: '/_root/integrations/monitoring/grafana/'
      path: '/'
      fullPath: '/integrations/monitoring/grafana/'
      preLoaderRoute: typeof RootIntegrationsMonitoringGrafanaIndexImport
      parentRoute: typeof RootIntegrationsMonitoringGrafanaRouteImport
    }
    '/_root/integrations/terraform-backend/buckets/': {
      id: '/_root/integrations/terraform-backend/buckets/'
      path: '/'
      fullPath: '/integrations/terraform-backend/buckets/'
      preLoaderRoute: typeof RootIntegrationsTerraformBackendBucketsIndexImport
      parentRoute: typeof RootIntegrationsTerraformBackendBucketsRouteImport
    }
    '/_root/integrations/terraform-backend/hcp-cloud/': {
      id: '/_root/integrations/terraform-backend/hcp-cloud/'
      path: '/'
      fullPath: '/integrations/terraform-backend/hcp-cloud/'
      preLoaderRoute: typeof RootIntegrationsTerraformBackendHcpCloudIndexImport
      parentRoute: typeof RootIntegrationsTerraformBackendHcpCloudRouteImport
    }
    '/_root/integrations/incidents-management/pagerduty/tokens/$tokenId': {
      id: '/_root/integrations/incidents-management/pagerduty/tokens/$tokenId'
      path: '/tokens/$tokenId'
      fullPath: '/integrations/incidents-management/pagerduty/tokens/$tokenId'
      preLoaderRoute: typeof RootIntegrationsIncidentsManagementPagerdutyTokensTokenIdImport
      parentRoute: typeof RootIntegrationsIncidentsManagementPagerdutyRouteImport
    }
    '/_root/integrations/incidents-management/pagerduty/tokens/new': {
      id: '/_root/integrations/incidents-management/pagerduty/tokens/new'
      path: '/tokens/new'
      fullPath: '/integrations/incidents-management/pagerduty/tokens/new'
      preLoaderRoute: typeof RootIntegrationsIncidentsManagementPagerdutyTokensNewImport
      parentRoute: typeof RootIntegrationsIncidentsManagementPagerdutyRouteImport
    }
    '/_root/integrations/incidents-management/pagerduty/webhooks/$webhookId': {
      id: '/_root/integrations/incidents-management/pagerduty/webhooks/$webhookId'
      path: '/webhooks/$webhookId'
      fullPath: '/integrations/incidents-management/pagerduty/webhooks/$webhookId'
      preLoaderRoute: typeof RootIntegrationsIncidentsManagementPagerdutyWebhooksWebhookIdImport
      parentRoute: typeof RootIntegrationsIncidentsManagementPagerdutyRouteImport
    }
    '/_root/integrations/incidents-management/pagerduty/webhooks/new': {
      id: '/_root/integrations/incidents-management/pagerduty/webhooks/new'
      path: '/webhooks/new'
      fullPath: '/integrations/incidents-management/pagerduty/webhooks/new'
      preLoaderRoute: typeof RootIntegrationsIncidentsManagementPagerdutyWebhooksNewImport
      parentRoute: typeof RootIntegrationsIncidentsManagementPagerdutyRouteImport
    }
  }
}

// Create and export the route tree

interface RootAdminRouteRouteChildren {
  RootAdminIndexRoute: typeof RootAdminIndexRoute
}

const RootAdminRouteRouteChildren: RootAdminRouteRouteChildren = {
  RootAdminIndexRoute: RootAdminIndexRoute,
}

const RootAdminRouteRouteWithChildren = RootAdminRouteRoute._addFileChildren(
  RootAdminRouteRouteChildren,
)

interface RootCatalogRouteRouteChildren {
  RootCatalogIndexRoute: typeof RootCatalogIndexRoute
}

const RootCatalogRouteRouteChildren: RootCatalogRouteRouteChildren = {
  RootCatalogIndexRoute: RootCatalogIndexRoute,
}

const RootCatalogRouteRouteWithChildren =
  RootCatalogRouteRoute._addFileChildren(RootCatalogRouteRouteChildren)

interface RootConfigurationRouteRouteChildren {
  RootConfigurationIndexRoute: typeof RootConfigurationIndexRoute
}

const RootConfigurationRouteRouteChildren: RootConfigurationRouteRouteChildren =
  {
    RootConfigurationIndexRoute: RootConfigurationIndexRoute,
  }

const RootConfigurationRouteRouteWithChildren =
  RootConfigurationRouteRoute._addFileChildren(
    RootConfigurationRouteRouteChildren,
  )

interface RootCoverageRouteRouteChildren {
  RootCoverageIndexRoute: typeof RootCoverageIndexRoute
}

const RootCoverageRouteRouteChildren: RootCoverageRouteRouteChildren = {
  RootCoverageIndexRoute: RootCoverageIndexRoute,
}

const RootCoverageRouteRouteWithChildren =
  RootCoverageRouteRoute._addFileChildren(RootCoverageRouteRouteChildren)

interface RootIntegrationsAwsRouteRouteChildren {
  RootIntegrationsAwsIndexRoute: typeof RootIntegrationsAwsIndexRoute
  RootIntegrationsAwsRolesRoleIdRoute: typeof RootIntegrationsAwsRolesRoleIdRoute
  RootIntegrationsAwsRolesNewRoute: typeof RootIntegrationsAwsRolesNewRoute
  RootIntegrationsAwsUsersUserIdRoute: typeof RootIntegrationsAwsUsersUserIdRoute
  RootIntegrationsAwsUsersNewRoute: typeof RootIntegrationsAwsUsersNewRoute
}

const RootIntegrationsAwsRouteRouteChildren: RootIntegrationsAwsRouteRouteChildren =
  {
    RootIntegrationsAwsIndexRoute: RootIntegrationsAwsIndexRoute,
    RootIntegrationsAwsRolesRoleIdRoute: RootIntegrationsAwsRolesRoleIdRoute,
    RootIntegrationsAwsRolesNewRoute: RootIntegrationsAwsRolesNewRoute,
    RootIntegrationsAwsUsersUserIdRoute: RootIntegrationsAwsUsersUserIdRoute,
    RootIntegrationsAwsUsersNewRoute: RootIntegrationsAwsUsersNewRoute,
  }

const RootIntegrationsAwsRouteRouteWithChildren =
  RootIntegrationsAwsRouteRoute._addFileChildren(
    RootIntegrationsAwsRouteRouteChildren,
  )

interface RootIntegrationsGcpServiceAccountsRouteRouteChildren {
  RootIntegrationsGcpServiceAccountsAccountIdRoute: typeof RootIntegrationsGcpServiceAccountsAccountIdRoute
  RootIntegrationsGcpServiceAccountsNewRoute: typeof RootIntegrationsGcpServiceAccountsNewRoute
  RootIntegrationsGcpServiceAccountsIndexRoute: typeof RootIntegrationsGcpServiceAccountsIndexRoute
}

const RootIntegrationsGcpServiceAccountsRouteRouteChildren: RootIntegrationsGcpServiceAccountsRouteRouteChildren =
  {
    RootIntegrationsGcpServiceAccountsAccountIdRoute:
      RootIntegrationsGcpServiceAccountsAccountIdRoute,
    RootIntegrationsGcpServiceAccountsNewRoute:
      RootIntegrationsGcpServiceAccountsNewRoute,
    RootIntegrationsGcpServiceAccountsIndexRoute:
      RootIntegrationsGcpServiceAccountsIndexRoute,
  }

const RootIntegrationsGcpServiceAccountsRouteRouteWithChildren =
  RootIntegrationsGcpServiceAccountsRouteRoute._addFileChildren(
    RootIntegrationsGcpServiceAccountsRouteRouteChildren,
  )

interface RootIntegrationsGcpRouteRouteChildren {
  RootIntegrationsGcpServiceAccountsRouteRoute: typeof RootIntegrationsGcpServiceAccountsRouteRouteWithChildren
  RootIntegrationsGcpIndexRoute: typeof RootIntegrationsGcpIndexRoute
}

const RootIntegrationsGcpRouteRouteChildren: RootIntegrationsGcpRouteRouteChildren =
  {
    RootIntegrationsGcpServiceAccountsRouteRoute:
      RootIntegrationsGcpServiceAccountsRouteRouteWithChildren,
    RootIntegrationsGcpIndexRoute: RootIntegrationsGcpIndexRoute,
  }

const RootIntegrationsGcpRouteRouteWithChildren =
  RootIntegrationsGcpRouteRoute._addFileChildren(
    RootIntegrationsGcpRouteRouteChildren,
  )

interface RootIntegrationsContainersKubernetesRouteRouteChildren {
  RootIntegrationsContainersKubernetesIndexRoute: typeof RootIntegrationsContainersKubernetesIndexRoute
}

const RootIntegrationsContainersKubernetesRouteRouteChildren: RootIntegrationsContainersKubernetesRouteRouteChildren =
  {
    RootIntegrationsContainersKubernetesIndexRoute:
      RootIntegrationsContainersKubernetesIndexRoute,
  }

const RootIntegrationsContainersKubernetesRouteRouteWithChildren =
  RootIntegrationsContainersKubernetesRouteRoute._addFileChildren(
    RootIntegrationsContainersKubernetesRouteRouteChildren,
  )

interface RootIntegrationsIncidentsManagementPagerdutyRouteRouteChildren {
  RootIntegrationsIncidentsManagementPagerdutyIndexRoute: typeof RootIntegrationsIncidentsManagementPagerdutyIndexRoute
  RootIntegrationsIncidentsManagementPagerdutyTokensTokenIdRoute: typeof RootIntegrationsIncidentsManagementPagerdutyTokensTokenIdRoute
  RootIntegrationsIncidentsManagementPagerdutyTokensNewRoute: typeof RootIntegrationsIncidentsManagementPagerdutyTokensNewRoute
  RootIntegrationsIncidentsManagementPagerdutyWebhooksWebhookIdRoute: typeof RootIntegrationsIncidentsManagementPagerdutyWebhooksWebhookIdRoute
  RootIntegrationsIncidentsManagementPagerdutyWebhooksNewRoute: typeof RootIntegrationsIncidentsManagementPagerdutyWebhooksNewRoute
}

const RootIntegrationsIncidentsManagementPagerdutyRouteRouteChildren: RootIntegrationsIncidentsManagementPagerdutyRouteRouteChildren =
  {
    RootIntegrationsIncidentsManagementPagerdutyIndexRoute:
      RootIntegrationsIncidentsManagementPagerdutyIndexRoute,
    RootIntegrationsIncidentsManagementPagerdutyTokensTokenIdRoute:
      RootIntegrationsIncidentsManagementPagerdutyTokensTokenIdRoute,
    RootIntegrationsIncidentsManagementPagerdutyTokensNewRoute:
      RootIntegrationsIncidentsManagementPagerdutyTokensNewRoute,
    RootIntegrationsIncidentsManagementPagerdutyWebhooksWebhookIdRoute:
      RootIntegrationsIncidentsManagementPagerdutyWebhooksWebhookIdRoute,
    RootIntegrationsIncidentsManagementPagerdutyWebhooksNewRoute:
      RootIntegrationsIncidentsManagementPagerdutyWebhooksNewRoute,
  }

const RootIntegrationsIncidentsManagementPagerdutyRouteRouteWithChildren =
  RootIntegrationsIncidentsManagementPagerdutyRouteRoute._addFileChildren(
    RootIntegrationsIncidentsManagementPagerdutyRouteRouteChildren,
  )

interface RootIntegrationsMessagingSlackRouteRouteChildren {
  RootIntegrationsMessagingSlackIndexRoute: typeof RootIntegrationsMessagingSlackIndexRoute
}

const RootIntegrationsMessagingSlackRouteRouteChildren: RootIntegrationsMessagingSlackRouteRouteChildren =
  {
    RootIntegrationsMessagingSlackIndexRoute:
      RootIntegrationsMessagingSlackIndexRoute,
  }

const RootIntegrationsMessagingSlackRouteRouteWithChildren =
  RootIntegrationsMessagingSlackRouteRoute._addFileChildren(
    RootIntegrationsMessagingSlackRouteRouteChildren,
  )

interface RootIntegrationsMonitoringDatadogApiCredentialsRouteRouteChildren {
  RootIntegrationsMonitoringDatadogApiCredentialsIdRoute: typeof RootIntegrationsMonitoringDatadogApiCredentialsIdRoute
  RootIntegrationsMonitoringDatadogApiCredentialsNewRoute: typeof RootIntegrationsMonitoringDatadogApiCredentialsNewRoute
  RootIntegrationsMonitoringDatadogApiCredentialsIndexRoute: typeof RootIntegrationsMonitoringDatadogApiCredentialsIndexRoute
}

const RootIntegrationsMonitoringDatadogApiCredentialsRouteRouteChildren: RootIntegrationsMonitoringDatadogApiCredentialsRouteRouteChildren =
  {
    RootIntegrationsMonitoringDatadogApiCredentialsIdRoute:
      RootIntegrationsMonitoringDatadogApiCredentialsIdRoute,
    RootIntegrationsMonitoringDatadogApiCredentialsNewRoute:
      RootIntegrationsMonitoringDatadogApiCredentialsNewRoute,
    RootIntegrationsMonitoringDatadogApiCredentialsIndexRoute:
      RootIntegrationsMonitoringDatadogApiCredentialsIndexRoute,
  }

const RootIntegrationsMonitoringDatadogApiCredentialsRouteRouteWithChildren =
  RootIntegrationsMonitoringDatadogApiCredentialsRouteRoute._addFileChildren(
    RootIntegrationsMonitoringDatadogApiCredentialsRouteRouteChildren,
  )

interface RootIntegrationsMonitoringGrafanaRouteRouteChildren {
  RootIntegrationsMonitoringGrafanaIdRoute: typeof RootIntegrationsMonitoringGrafanaIdRoute
  RootIntegrationsMonitoringGrafanaNewRoute: typeof RootIntegrationsMonitoringGrafanaNewRoute
  RootIntegrationsMonitoringGrafanaIndexRoute: typeof RootIntegrationsMonitoringGrafanaIndexRoute
}

const RootIntegrationsMonitoringGrafanaRouteRouteChildren: RootIntegrationsMonitoringGrafanaRouteRouteChildren =
  {
    RootIntegrationsMonitoringGrafanaIdRoute:
      RootIntegrationsMonitoringGrafanaIdRoute,
    RootIntegrationsMonitoringGrafanaNewRoute:
      RootIntegrationsMonitoringGrafanaNewRoute,
    RootIntegrationsMonitoringGrafanaIndexRoute:
      RootIntegrationsMonitoringGrafanaIndexRoute,
  }

const RootIntegrationsMonitoringGrafanaRouteRouteWithChildren =
  RootIntegrationsMonitoringGrafanaRouteRoute._addFileChildren(
    RootIntegrationsMonitoringGrafanaRouteRouteChildren,
  )

interface RootIntegrationsTerraformBackendBucketsRouteRouteChildren {
  RootIntegrationsTerraformBackendBucketsIndexRoute: typeof RootIntegrationsTerraformBackendBucketsIndexRoute
}

const RootIntegrationsTerraformBackendBucketsRouteRouteChildren: RootIntegrationsTerraformBackendBucketsRouteRouteChildren =
  {
    RootIntegrationsTerraformBackendBucketsIndexRoute:
      RootIntegrationsTerraformBackendBucketsIndexRoute,
  }

const RootIntegrationsTerraformBackendBucketsRouteRouteWithChildren =
  RootIntegrationsTerraformBackendBucketsRouteRoute._addFileChildren(
    RootIntegrationsTerraformBackendBucketsRouteRouteChildren,
  )

interface RootIntegrationsTerraformBackendHcpCloudRouteRouteChildren {
  RootIntegrationsTerraformBackendHcpCloudTokenIdRoute: typeof RootIntegrationsTerraformBackendHcpCloudTokenIdRoute
  RootIntegrationsTerraformBackendHcpCloudNewRoute: typeof RootIntegrationsTerraformBackendHcpCloudNewRoute
  RootIntegrationsTerraformBackendHcpCloudIndexRoute: typeof RootIntegrationsTerraformBackendHcpCloudIndexRoute
}

const RootIntegrationsTerraformBackendHcpCloudRouteRouteChildren: RootIntegrationsTerraformBackendHcpCloudRouteRouteChildren =
  {
    RootIntegrationsTerraformBackendHcpCloudTokenIdRoute:
      RootIntegrationsTerraformBackendHcpCloudTokenIdRoute,
    RootIntegrationsTerraformBackendHcpCloudNewRoute:
      RootIntegrationsTerraformBackendHcpCloudNewRoute,
    RootIntegrationsTerraformBackendHcpCloudIndexRoute:
      RootIntegrationsTerraformBackendHcpCloudIndexRoute,
  }

const RootIntegrationsTerraformBackendHcpCloudRouteRouteWithChildren =
  RootIntegrationsTerraformBackendHcpCloudRouteRoute._addFileChildren(
    RootIntegrationsTerraformBackendHcpCloudRouteRouteChildren,
  )

interface RootIntegrationsRouteRouteChildren {
  RootIntegrationsAwsRouteRoute: typeof RootIntegrationsAwsRouteRouteWithChildren
  RootIntegrationsGcpRouteRoute: typeof RootIntegrationsGcpRouteRouteWithChildren
  RootIntegrationsIndexRoute: typeof RootIntegrationsIndexRoute
  RootIntegrationsContainersKubernetesRouteRoute: typeof RootIntegrationsContainersKubernetesRouteRouteWithChildren
  RootIntegrationsIncidentsManagementPagerdutyRouteRoute: typeof RootIntegrationsIncidentsManagementPagerdutyRouteRouteWithChildren
  RootIntegrationsMessagingSlackRouteRoute: typeof RootIntegrationsMessagingSlackRouteRouteWithChildren
  RootIntegrationsMonitoringDatadogApiCredentialsRouteRoute: typeof RootIntegrationsMonitoringDatadogApiCredentialsRouteRouteWithChildren
  RootIntegrationsMonitoringGrafanaRouteRoute: typeof RootIntegrationsMonitoringGrafanaRouteRouteWithChildren
  RootIntegrationsTerraformBackendBucketsRouteRoute: typeof RootIntegrationsTerraformBackendBucketsRouteRouteWithChildren
  RootIntegrationsTerraformBackendHcpCloudRouteRoute: typeof RootIntegrationsTerraformBackendHcpCloudRouteRouteWithChildren
  RootIntegrationsGitlabIndexRoute: typeof RootIntegrationsGitlabIndexRoute
}

const RootIntegrationsRouteRouteChildren: RootIntegrationsRouteRouteChildren = {
  RootIntegrationsAwsRouteRoute: RootIntegrationsAwsRouteRouteWithChildren,
  RootIntegrationsGcpRouteRoute: RootIntegrationsGcpRouteRouteWithChildren,
  RootIntegrationsIndexRoute: RootIntegrationsIndexRoute,
  RootIntegrationsContainersKubernetesRouteRoute:
    RootIntegrationsContainersKubernetesRouteRouteWithChildren,
  RootIntegrationsIncidentsManagementPagerdutyRouteRoute:
    RootIntegrationsIncidentsManagementPagerdutyRouteRouteWithChildren,
  RootIntegrationsMessagingSlackRouteRoute:
    RootIntegrationsMessagingSlackRouteRouteWithChildren,
  RootIntegrationsMonitoringDatadogApiCredentialsRouteRoute:
    RootIntegrationsMonitoringDatadogApiCredentialsRouteRouteWithChildren,
  RootIntegrationsMonitoringGrafanaRouteRoute:
    RootIntegrationsMonitoringGrafanaRouteRouteWithChildren,
  RootIntegrationsTerraformBackendBucketsRouteRoute:
    RootIntegrationsTerraformBackendBucketsRouteRouteWithChildren,
  RootIntegrationsTerraformBackendHcpCloudRouteRoute:
    RootIntegrationsTerraformBackendHcpCloudRouteRouteWithChildren,
  RootIntegrationsGitlabIndexRoute: RootIntegrationsGitlabIndexRoute,
}

const RootIntegrationsRouteRouteWithChildren =
  RootIntegrationsRouteRoute._addFileChildren(
    RootIntegrationsRouteRouteChildren,
  )

interface RootRcaRouteRouteChildren {
  RootRcaIndexRoute: typeof RootRcaIndexRoute
  RootRcaIncidentIdIndexRoute: typeof RootRcaIncidentIdIndexRoute
}

const RootRcaRouteRouteChildren: RootRcaRouteRouteChildren = {
  RootRcaIndexRoute: RootRcaIndexRoute,
  RootRcaIncidentIdIndexRoute: RootRcaIncidentIdIndexRoute,
}

const RootRcaRouteRouteWithChildren = RootRcaRouteRoute._addFileChildren(
  RootRcaRouteRouteChildren,
)

interface RootRcaDemoRouteRouteChildren {
  RootRcaDemoIndexRoute: typeof RootRcaDemoIndexRoute
  RootRcaDemoIncidentIdIndexRoute: typeof RootRcaDemoIncidentIdIndexRoute
}

const RootRcaDemoRouteRouteChildren: RootRcaDemoRouteRouteChildren = {
  RootRcaDemoIndexRoute: RootRcaDemoIndexRoute,
  RootRcaDemoIncidentIdIndexRoute: RootRcaDemoIncidentIdIndexRoute,
}

const RootRcaDemoRouteRouteWithChildren =
  RootRcaDemoRouteRoute._addFileChildren(RootRcaDemoRouteRouteChildren)

interface RootRouteRouteChildren {
  RootAdminRouteRoute: typeof RootAdminRouteRouteWithChildren
  RootCatalogRouteRoute: typeof RootCatalogRouteRouteWithChildren
  RootConfigurationRouteRoute: typeof RootConfigurationRouteRouteWithChildren
  RootCoverageRouteRoute: typeof RootCoverageRouteRouteWithChildren
  RootIntegrationsRouteRoute: typeof RootIntegrationsRouteRouteWithChildren
  RootRcaRouteRoute: typeof RootRcaRouteRouteWithChildren
  RootRcaDemoRouteRoute: typeof RootRcaDemoRouteRouteWithChildren
  RootIndexRoute: typeof RootIndexRoute
  RootGettingStartedSlackChannelsRoute: typeof RootGettingStartedSlackChannelsRoute
  RootResourceResourceIdRoute: typeof RootResourceResourceIdRoute
  RootGettingStartedIndexRoute: typeof RootGettingStartedIndexRoute
  RootMyProfileIndexRoute: typeof RootMyProfileIndexRoute
  RootNewProjectIndexRoute: typeof RootNewProjectIndexRoute
  RootPullRequestIndexRoute: typeof RootPullRequestIndexRoute
  RootSearchIndexRoute: typeof RootSearchIndexRoute
}

const RootRouteRouteChildren: RootRouteRouteChildren = {
  RootAdminRouteRoute: RootAdminRouteRouteWithChildren,
  RootCatalogRouteRoute: RootCatalogRouteRouteWithChildren,
  RootConfigurationRouteRoute: RootConfigurationRouteRouteWithChildren,
  RootCoverageRouteRoute: RootCoverageRouteRouteWithChildren,
  RootIntegrationsRouteRoute: RootIntegrationsRouteRouteWithChildren,
  RootRcaRouteRoute: RootRcaRouteRouteWithChildren,
  RootRcaDemoRouteRoute: RootRcaDemoRouteRouteWithChildren,
  RootIndexRoute: RootIndexRoute,
  RootGettingStartedSlackChannelsRoute: RootGettingStartedSlackChannelsRoute,
  RootResourceResourceIdRoute: RootResourceResourceIdRoute,
  RootGettingStartedIndexRoute: RootGettingStartedIndexRoute,
  RootMyProfileIndexRoute: RootMyProfileIndexRoute,
  RootNewProjectIndexRoute: RootNewProjectIndexRoute,
  RootPullRequestIndexRoute: RootPullRequestIndexRoute,
  RootSearchIndexRoute: RootSearchIndexRoute,
}

const RootRouteRouteWithChildren = RootRouteRoute._addFileChildren(
  RootRouteRouteChildren,
)

interface GithubCallbackRouteRouteChildren {
  GithubCallbackAuthenticatedRoute: typeof GithubCallbackAuthenticatedRoute
  GithubCallbackInstalledRoute: typeof GithubCallbackInstalledRoute
}

const GithubCallbackRouteRouteChildren: GithubCallbackRouteRouteChildren = {
  GithubCallbackAuthenticatedRoute: GithubCallbackAuthenticatedRoute,
  GithubCallbackInstalledRoute: GithubCallbackInstalledRoute,
}

const GithubCallbackRouteRouteWithChildren =
  GithubCallbackRouteRoute._addFileChildren(GithubCallbackRouteRouteChildren)

interface GitlabCallbackRouteRouteChildren {
  GitlabCallbackAuthenticatedRoute: typeof GitlabCallbackAuthenticatedRoute
  GitlabCallbackInstalledRoute: typeof GitlabCallbackInstalledRoute
}

const GitlabCallbackRouteRouteChildren: GitlabCallbackRouteRouteChildren = {
  GitlabCallbackAuthenticatedRoute: GitlabCallbackAuthenticatedRoute,
  GitlabCallbackInstalledRoute: GitlabCallbackInstalledRoute,
}

const GitlabCallbackRouteRouteWithChildren =
  GitlabCallbackRouteRoute._addFileChildren(GitlabCallbackRouteRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof RootRouteRouteWithChildren
  '/github-callback': typeof GithubCallbackRouteRouteWithChildren
  '/gitlab-callback': typeof GitlabCallbackRouteRouteWithChildren
  '/admin': typeof RootAdminRouteRouteWithChildren
  '/catalog': typeof RootCatalogRouteRouteWithChildren
  '/configuration': typeof RootConfigurationRouteRouteWithChildren
  '/coverage': typeof RootCoverageRouteRouteWithChildren
  '/integrations': typeof RootIntegrationsRouteRouteWithChildren
  '/rca': typeof RootRcaRouteRouteWithChildren
  '/rca-demo': typeof RootRcaDemoRouteRouteWithChildren
  '/github-callback/authenticated': typeof GithubCallbackAuthenticatedRoute
  '/github-callback/installed': typeof GithubCallbackInstalledRoute
  '/gitlab-callback/authenticated': typeof GitlabCallbackAuthenticatedRoute
  '/gitlab-callback/installed': typeof GitlabCallbackInstalledRoute
  '/': typeof RootIndexRoute
  '/integrations/aws': typeof RootIntegrationsAwsRouteRouteWithChildren
  '/integrations/gcp': typeof RootIntegrationsGcpRouteRouteWithChildren
  '/getting-started/slack-channels': typeof RootGettingStartedSlackChannelsRoute
  '/resource/$resourceId': typeof RootResourceResourceIdRoute
  '/forgot-password': typeof authForgotPasswordIndexRoute
  '/not-verified': typeof authNotVerifiedIndexRoute
  '/reset-password-on-invitation': typeof authResetPasswordOnInvitationIndexRoute
  '/reset-password': typeof authResetPasswordIndexRoute
  '/sign-in': typeof authSignInIndexRoute
  '/sign-up': typeof authSignUpIndexRoute
  '/slack-not-linked': typeof authSlackNotLinkedIndexRoute
  '/admin/': typeof RootAdminIndexRoute
  '/catalog/': typeof RootCatalogIndexRoute
  '/configuration/': typeof RootConfigurationIndexRoute
  '/coverage/': typeof RootCoverageIndexRoute
  '/getting-started': typeof RootGettingStartedIndexRoute
  '/integrations/': typeof RootIntegrationsIndexRoute
  '/my-profile': typeof RootMyProfileIndexRoute
  '/new-project': typeof RootNewProjectIndexRoute
  '/pull-request': typeof RootPullRequestIndexRoute
  '/rca-demo/': typeof RootRcaDemoIndexRoute
  '/rca/': typeof RootRcaIndexRoute
  '/search': typeof RootSearchIndexRoute
  '/integrations/containers/kubernetes': typeof RootIntegrationsContainersKubernetesRouteRouteWithChildren
  '/integrations/gcp/service-accounts': typeof RootIntegrationsGcpServiceAccountsRouteRouteWithChildren
  '/integrations/incidents-management/pagerduty': typeof RootIntegrationsIncidentsManagementPagerdutyRouteRouteWithChildren
  '/integrations/messaging/slack': typeof RootIntegrationsMessagingSlackRouteRouteWithChildren
  '/integrations/monitoring/datadog-api-credentials': typeof RootIntegrationsMonitoringDatadogApiCredentialsRouteRouteWithChildren
  '/integrations/monitoring/grafana': typeof RootIntegrationsMonitoringGrafanaRouteRouteWithChildren
  '/integrations/terraform-backend/buckets': typeof RootIntegrationsTerraformBackendBucketsRouteRouteWithChildren
  '/integrations/terraform-backend/hcp-cloud': typeof RootIntegrationsTerraformBackendHcpCloudRouteRouteWithChildren
  '/integrations/aws/': typeof RootIntegrationsAwsIndexRoute
  '/integrations/gcp/': typeof RootIntegrationsGcpIndexRoute
  '/integrations/gitlab': typeof RootIntegrationsGitlabIndexRoute
  '/rca-demo/$incidentId': typeof RootRcaDemoIncidentIdIndexRoute
  '/rca/$incidentId': typeof RootRcaIncidentIdIndexRoute
  '/integrations/aws/roles/$roleId': typeof RootIntegrationsAwsRolesRoleIdRoute
  '/integrations/aws/roles/new': typeof RootIntegrationsAwsRolesNewRoute
  '/integrations/aws/users/$userId': typeof RootIntegrationsAwsUsersUserIdRoute
  '/integrations/aws/users/new': typeof RootIntegrationsAwsUsersNewRoute
  '/integrations/gcp/service-accounts/$accountId': typeof RootIntegrationsGcpServiceAccountsAccountIdRoute
  '/integrations/gcp/service-accounts/new': typeof RootIntegrationsGcpServiceAccountsNewRoute
  '/integrations/monitoring/datadog-api-credentials/$id': typeof RootIntegrationsMonitoringDatadogApiCredentialsIdRoute
  '/integrations/monitoring/datadog-api-credentials/new': typeof RootIntegrationsMonitoringDatadogApiCredentialsNewRoute
  '/integrations/monitoring/grafana/$id': typeof RootIntegrationsMonitoringGrafanaIdRoute
  '/integrations/monitoring/grafana/new': typeof RootIntegrationsMonitoringGrafanaNewRoute
  '/integrations/terraform-backend/hcp-cloud/$tokenId': typeof RootIntegrationsTerraformBackendHcpCloudTokenIdRoute
  '/integrations/terraform-backend/hcp-cloud/new': typeof RootIntegrationsTerraformBackendHcpCloudNewRoute
  '/integrations/containers/kubernetes/': typeof RootIntegrationsContainersKubernetesIndexRoute
  '/integrations/gcp/service-accounts/': typeof RootIntegrationsGcpServiceAccountsIndexRoute
  '/integrations/incidents-management/pagerduty/': typeof RootIntegrationsIncidentsManagementPagerdutyIndexRoute
  '/integrations/messaging/slack/': typeof RootIntegrationsMessagingSlackIndexRoute
  '/integrations/monitoring/datadog-api-credentials/': typeof RootIntegrationsMonitoringDatadogApiCredentialsIndexRoute
  '/integrations/monitoring/grafana/': typeof RootIntegrationsMonitoringGrafanaIndexRoute
  '/integrations/terraform-backend/buckets/': typeof RootIntegrationsTerraformBackendBucketsIndexRoute
  '/integrations/terraform-backend/hcp-cloud/': typeof RootIntegrationsTerraformBackendHcpCloudIndexRoute
  '/integrations/incidents-management/pagerduty/tokens/$tokenId': typeof RootIntegrationsIncidentsManagementPagerdutyTokensTokenIdRoute
  '/integrations/incidents-management/pagerduty/tokens/new': typeof RootIntegrationsIncidentsManagementPagerdutyTokensNewRoute
  '/integrations/incidents-management/pagerduty/webhooks/$webhookId': typeof RootIntegrationsIncidentsManagementPagerdutyWebhooksWebhookIdRoute
  '/integrations/incidents-management/pagerduty/webhooks/new': typeof RootIntegrationsIncidentsManagementPagerdutyWebhooksNewRoute
}

export interface FileRoutesByTo {
  '/github-callback': typeof GithubCallbackRouteRouteWithChildren
  '/gitlab-callback': typeof GitlabCallbackRouteRouteWithChildren
  '/github-callback/authenticated': typeof GithubCallbackAuthenticatedRoute
  '/github-callback/installed': typeof GithubCallbackInstalledRoute
  '/gitlab-callback/authenticated': typeof GitlabCallbackAuthenticatedRoute
  '/gitlab-callback/installed': typeof GitlabCallbackInstalledRoute
  '/': typeof RootIndexRoute
  '/getting-started/slack-channels': typeof RootGettingStartedSlackChannelsRoute
  '/resource/$resourceId': typeof RootResourceResourceIdRoute
  '/forgot-password': typeof authForgotPasswordIndexRoute
  '/not-verified': typeof authNotVerifiedIndexRoute
  '/reset-password-on-invitation': typeof authResetPasswordOnInvitationIndexRoute
  '/reset-password': typeof authResetPasswordIndexRoute
  '/sign-in': typeof authSignInIndexRoute
  '/sign-up': typeof authSignUpIndexRoute
  '/slack-not-linked': typeof authSlackNotLinkedIndexRoute
  '/admin': typeof RootAdminIndexRoute
  '/catalog': typeof RootCatalogIndexRoute
  '/configuration': typeof RootConfigurationIndexRoute
  '/coverage': typeof RootCoverageIndexRoute
  '/getting-started': typeof RootGettingStartedIndexRoute
  '/integrations': typeof RootIntegrationsIndexRoute
  '/my-profile': typeof RootMyProfileIndexRoute
  '/new-project': typeof RootNewProjectIndexRoute
  '/pull-request': typeof RootPullRequestIndexRoute
  '/rca-demo': typeof RootRcaDemoIndexRoute
  '/rca': typeof RootRcaIndexRoute
  '/search': typeof RootSearchIndexRoute
  '/integrations/aws': typeof RootIntegrationsAwsIndexRoute
  '/integrations/gcp': typeof RootIntegrationsGcpIndexRoute
  '/integrations/gitlab': typeof RootIntegrationsGitlabIndexRoute
  '/rca-demo/$incidentId': typeof RootRcaDemoIncidentIdIndexRoute
  '/rca/$incidentId': typeof RootRcaIncidentIdIndexRoute
  '/integrations/aws/roles/$roleId': typeof RootIntegrationsAwsRolesRoleIdRoute
  '/integrations/aws/roles/new': typeof RootIntegrationsAwsRolesNewRoute
  '/integrations/aws/users/$userId': typeof RootIntegrationsAwsUsersUserIdRoute
  '/integrations/aws/users/new': typeof RootIntegrationsAwsUsersNewRoute
  '/integrations/gcp/service-accounts/$accountId': typeof RootIntegrationsGcpServiceAccountsAccountIdRoute
  '/integrations/gcp/service-accounts/new': typeof RootIntegrationsGcpServiceAccountsNewRoute
  '/integrations/monitoring/datadog-api-credentials/$id': typeof RootIntegrationsMonitoringDatadogApiCredentialsIdRoute
  '/integrations/monitoring/datadog-api-credentials/new': typeof RootIntegrationsMonitoringDatadogApiCredentialsNewRoute
  '/integrations/monitoring/grafana/$id': typeof RootIntegrationsMonitoringGrafanaIdRoute
  '/integrations/monitoring/grafana/new': typeof RootIntegrationsMonitoringGrafanaNewRoute
  '/integrations/terraform-backend/hcp-cloud/$tokenId': typeof RootIntegrationsTerraformBackendHcpCloudTokenIdRoute
  '/integrations/terraform-backend/hcp-cloud/new': typeof RootIntegrationsTerraformBackendHcpCloudNewRoute
  '/integrations/containers/kubernetes': typeof RootIntegrationsContainersKubernetesIndexRoute
  '/integrations/gcp/service-accounts': typeof RootIntegrationsGcpServiceAccountsIndexRoute
  '/integrations/incidents-management/pagerduty': typeof RootIntegrationsIncidentsManagementPagerdutyIndexRoute
  '/integrations/messaging/slack': typeof RootIntegrationsMessagingSlackIndexRoute
  '/integrations/monitoring/datadog-api-credentials': typeof RootIntegrationsMonitoringDatadogApiCredentialsIndexRoute
  '/integrations/monitoring/grafana': typeof RootIntegrationsMonitoringGrafanaIndexRoute
  '/integrations/terraform-backend/buckets': typeof RootIntegrationsTerraformBackendBucketsIndexRoute
  '/integrations/terraform-backend/hcp-cloud': typeof RootIntegrationsTerraformBackendHcpCloudIndexRoute
  '/integrations/incidents-management/pagerduty/tokens/$tokenId': typeof RootIntegrationsIncidentsManagementPagerdutyTokensTokenIdRoute
  '/integrations/incidents-management/pagerduty/tokens/new': typeof RootIntegrationsIncidentsManagementPagerdutyTokensNewRoute
  '/integrations/incidents-management/pagerduty/webhooks/$webhookId': typeof RootIntegrationsIncidentsManagementPagerdutyWebhooksWebhookIdRoute
  '/integrations/incidents-management/pagerduty/webhooks/new': typeof RootIntegrationsIncidentsManagementPagerdutyWebhooksNewRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_root': typeof RootRouteRouteWithChildren
  '/github-callback': typeof GithubCallbackRouteRouteWithChildren
  '/gitlab-callback': typeof GitlabCallbackRouteRouteWithChildren
  '/_root/admin': typeof RootAdminRouteRouteWithChildren
  '/_root/catalog': typeof RootCatalogRouteRouteWithChildren
  '/_root/configuration': typeof RootConfigurationRouteRouteWithChildren
  '/_root/coverage': typeof RootCoverageRouteRouteWithChildren
  '/_root/integrations': typeof RootIntegrationsRouteRouteWithChildren
  '/_root/rca': typeof RootRcaRouteRouteWithChildren
  '/_root/rca-demo': typeof RootRcaDemoRouteRouteWithChildren
  '/github-callback/authenticated': typeof GithubCallbackAuthenticatedRoute
  '/github-callback/installed': typeof GithubCallbackInstalledRoute
  '/gitlab-callback/authenticated': typeof GitlabCallbackAuthenticatedRoute
  '/gitlab-callback/installed': typeof GitlabCallbackInstalledRoute
  '/_root/': typeof RootIndexRoute
  '/_root/integrations/aws': typeof RootIntegrationsAwsRouteRouteWithChildren
  '/_root/integrations/gcp': typeof RootIntegrationsGcpRouteRouteWithChildren
  '/_root/getting-started/slack-channels': typeof RootGettingStartedSlackChannelsRoute
  '/_root/resource/$resourceId': typeof RootResourceResourceIdRoute
  '/(auth)/forgot-password/': typeof authForgotPasswordIndexRoute
  '/(auth)/not-verified/': typeof authNotVerifiedIndexRoute
  '/(auth)/reset-password-on-invitation/': typeof authResetPasswordOnInvitationIndexRoute
  '/(auth)/reset-password/': typeof authResetPasswordIndexRoute
  '/(auth)/sign-in/': typeof authSignInIndexRoute
  '/(auth)/sign-up/': typeof authSignUpIndexRoute
  '/(auth)/slack-not-linked/': typeof authSlackNotLinkedIndexRoute
  '/_root/admin/': typeof RootAdminIndexRoute
  '/_root/catalog/': typeof RootCatalogIndexRoute
  '/_root/configuration/': typeof RootConfigurationIndexRoute
  '/_root/coverage/': typeof RootCoverageIndexRoute
  '/_root/getting-started/': typeof RootGettingStartedIndexRoute
  '/_root/integrations/': typeof RootIntegrationsIndexRoute
  '/_root/my-profile/': typeof RootMyProfileIndexRoute
  '/_root/new-project/': typeof RootNewProjectIndexRoute
  '/_root/pull-request/': typeof RootPullRequestIndexRoute
  '/_root/rca-demo/': typeof RootRcaDemoIndexRoute
  '/_root/rca/': typeof RootRcaIndexRoute
  '/_root/search/': typeof RootSearchIndexRoute
  '/_root/integrations/containers/kubernetes': typeof RootIntegrationsContainersKubernetesRouteRouteWithChildren
  '/_root/integrations/gcp/service-accounts': typeof RootIntegrationsGcpServiceAccountsRouteRouteWithChildren
  '/_root/integrations/incidents-management/pagerduty': typeof RootIntegrationsIncidentsManagementPagerdutyRouteRouteWithChildren
  '/_root/integrations/messaging/slack': typeof RootIntegrationsMessagingSlackRouteRouteWithChildren
  '/_root/integrations/monitoring/datadog-api-credentials': typeof RootIntegrationsMonitoringDatadogApiCredentialsRouteRouteWithChildren
  '/_root/integrations/monitoring/grafana': typeof RootIntegrationsMonitoringGrafanaRouteRouteWithChildren
  '/_root/integrations/terraform-backend/buckets': typeof RootIntegrationsTerraformBackendBucketsRouteRouteWithChildren
  '/_root/integrations/terraform-backend/hcp-cloud': typeof RootIntegrationsTerraformBackendHcpCloudRouteRouteWithChildren
  '/_root/integrations/aws/': typeof RootIntegrationsAwsIndexRoute
  '/_root/integrations/gcp/': typeof RootIntegrationsGcpIndexRoute
  '/_root/integrations/gitlab/': typeof RootIntegrationsGitlabIndexRoute
  '/_root/rca-demo/$incidentId/': typeof RootRcaDemoIncidentIdIndexRoute
  '/_root/rca/$incidentId/': typeof RootRcaIncidentIdIndexRoute
  '/_root/integrations/aws/roles/$roleId': typeof RootIntegrationsAwsRolesRoleIdRoute
  '/_root/integrations/aws/roles/new': typeof RootIntegrationsAwsRolesNewRoute
  '/_root/integrations/aws/users/$userId': typeof RootIntegrationsAwsUsersUserIdRoute
  '/_root/integrations/aws/users/new': typeof RootIntegrationsAwsUsersNewRoute
  '/_root/integrations/gcp/service-accounts/$accountId': typeof RootIntegrationsGcpServiceAccountsAccountIdRoute
  '/_root/integrations/gcp/service-accounts/new': typeof RootIntegrationsGcpServiceAccountsNewRoute
  '/_root/integrations/monitoring/datadog-api-credentials/$id': typeof RootIntegrationsMonitoringDatadogApiCredentialsIdRoute
  '/_root/integrations/monitoring/datadog-api-credentials/new': typeof RootIntegrationsMonitoringDatadogApiCredentialsNewRoute
  '/_root/integrations/monitoring/grafana/$id': typeof RootIntegrationsMonitoringGrafanaIdRoute
  '/_root/integrations/monitoring/grafana/new': typeof RootIntegrationsMonitoringGrafanaNewRoute
  '/_root/integrations/terraform-backend/hcp-cloud/$tokenId': typeof RootIntegrationsTerraformBackendHcpCloudTokenIdRoute
  '/_root/integrations/terraform-backend/hcp-cloud/new': typeof RootIntegrationsTerraformBackendHcpCloudNewRoute
  '/_root/integrations/containers/kubernetes/': typeof RootIntegrationsContainersKubernetesIndexRoute
  '/_root/integrations/gcp/service-accounts/': typeof RootIntegrationsGcpServiceAccountsIndexRoute
  '/_root/integrations/incidents-management/pagerduty/': typeof RootIntegrationsIncidentsManagementPagerdutyIndexRoute
  '/_root/integrations/messaging/slack/': typeof RootIntegrationsMessagingSlackIndexRoute
  '/_root/integrations/monitoring/datadog-api-credentials/': typeof RootIntegrationsMonitoringDatadogApiCredentialsIndexRoute
  '/_root/integrations/monitoring/grafana/': typeof RootIntegrationsMonitoringGrafanaIndexRoute
  '/_root/integrations/terraform-backend/buckets/': typeof RootIntegrationsTerraformBackendBucketsIndexRoute
  '/_root/integrations/terraform-backend/hcp-cloud/': typeof RootIntegrationsTerraformBackendHcpCloudIndexRoute
  '/_root/integrations/incidents-management/pagerduty/tokens/$tokenId': typeof RootIntegrationsIncidentsManagementPagerdutyTokensTokenIdRoute
  '/_root/integrations/incidents-management/pagerduty/tokens/new': typeof RootIntegrationsIncidentsManagementPagerdutyTokensNewRoute
  '/_root/integrations/incidents-management/pagerduty/webhooks/$webhookId': typeof RootIntegrationsIncidentsManagementPagerdutyWebhooksWebhookIdRoute
  '/_root/integrations/incidents-management/pagerduty/webhooks/new': typeof RootIntegrationsIncidentsManagementPagerdutyWebhooksNewRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/github-callback'
    | '/gitlab-callback'
    | '/admin'
    | '/catalog'
    | '/configuration'
    | '/coverage'
    | '/integrations'
    | '/rca'
    | '/rca-demo'
    | '/github-callback/authenticated'
    | '/github-callback/installed'
    | '/gitlab-callback/authenticated'
    | '/gitlab-callback/installed'
    | '/'
    | '/integrations/aws'
    | '/integrations/gcp'
    | '/getting-started/slack-channels'
    | '/resource/$resourceId'
    | '/forgot-password'
    | '/not-verified'
    | '/reset-password-on-invitation'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/slack-not-linked'
    | '/admin/'
    | '/catalog/'
    | '/configuration/'
    | '/coverage/'
    | '/getting-started'
    | '/integrations/'
    | '/my-profile'
    | '/new-project'
    | '/pull-request'
    | '/rca-demo/'
    | '/rca/'
    | '/search'
    | '/integrations/containers/kubernetes'
    | '/integrations/gcp/service-accounts'
    | '/integrations/incidents-management/pagerduty'
    | '/integrations/messaging/slack'
    | '/integrations/monitoring/datadog-api-credentials'
    | '/integrations/monitoring/grafana'
    | '/integrations/terraform-backend/buckets'
    | '/integrations/terraform-backend/hcp-cloud'
    | '/integrations/aws/'
    | '/integrations/gcp/'
    | '/integrations/gitlab'
    | '/rca-demo/$incidentId'
    | '/rca/$incidentId'
    | '/integrations/aws/roles/$roleId'
    | '/integrations/aws/roles/new'
    | '/integrations/aws/users/$userId'
    | '/integrations/aws/users/new'
    | '/integrations/gcp/service-accounts/$accountId'
    | '/integrations/gcp/service-accounts/new'
    | '/integrations/monitoring/datadog-api-credentials/$id'
    | '/integrations/monitoring/datadog-api-credentials/new'
    | '/integrations/monitoring/grafana/$id'
    | '/integrations/monitoring/grafana/new'
    | '/integrations/terraform-backend/hcp-cloud/$tokenId'
    | '/integrations/terraform-backend/hcp-cloud/new'
    | '/integrations/containers/kubernetes/'
    | '/integrations/gcp/service-accounts/'
    | '/integrations/incidents-management/pagerduty/'
    | '/integrations/messaging/slack/'
    | '/integrations/monitoring/datadog-api-credentials/'
    | '/integrations/monitoring/grafana/'
    | '/integrations/terraform-backend/buckets/'
    | '/integrations/terraform-backend/hcp-cloud/'
    | '/integrations/incidents-management/pagerduty/tokens/$tokenId'
    | '/integrations/incidents-management/pagerduty/tokens/new'
    | '/integrations/incidents-management/pagerduty/webhooks/$webhookId'
    | '/integrations/incidents-management/pagerduty/webhooks/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/github-callback'
    | '/gitlab-callback'
    | '/github-callback/authenticated'
    | '/github-callback/installed'
    | '/gitlab-callback/authenticated'
    | '/gitlab-callback/installed'
    | '/'
    | '/getting-started/slack-channels'
    | '/resource/$resourceId'
    | '/forgot-password'
    | '/not-verified'
    | '/reset-password-on-invitation'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/slack-not-linked'
    | '/admin'
    | '/catalog'
    | '/configuration'
    | '/coverage'
    | '/getting-started'
    | '/integrations'
    | '/my-profile'
    | '/new-project'
    | '/pull-request'
    | '/rca-demo'
    | '/rca'
    | '/search'
    | '/integrations/aws'
    | '/integrations/gcp'
    | '/integrations/gitlab'
    | '/rca-demo/$incidentId'
    | '/rca/$incidentId'
    | '/integrations/aws/roles/$roleId'
    | '/integrations/aws/roles/new'
    | '/integrations/aws/users/$userId'
    | '/integrations/aws/users/new'
    | '/integrations/gcp/service-accounts/$accountId'
    | '/integrations/gcp/service-accounts/new'
    | '/integrations/monitoring/datadog-api-credentials/$id'
    | '/integrations/monitoring/datadog-api-credentials/new'
    | '/integrations/monitoring/grafana/$id'
    | '/integrations/monitoring/grafana/new'
    | '/integrations/terraform-backend/hcp-cloud/$tokenId'
    | '/integrations/terraform-backend/hcp-cloud/new'
    | '/integrations/containers/kubernetes'
    | '/integrations/gcp/service-accounts'
    | '/integrations/incidents-management/pagerduty'
    | '/integrations/messaging/slack'
    | '/integrations/monitoring/datadog-api-credentials'
    | '/integrations/monitoring/grafana'
    | '/integrations/terraform-backend/buckets'
    | '/integrations/terraform-backend/hcp-cloud'
    | '/integrations/incidents-management/pagerduty/tokens/$tokenId'
    | '/integrations/incidents-management/pagerduty/tokens/new'
    | '/integrations/incidents-management/pagerduty/webhooks/$webhookId'
    | '/integrations/incidents-management/pagerduty/webhooks/new'
  id:
    | '__root__'
    | '/_root'
    | '/github-callback'
    | '/gitlab-callback'
    | '/_root/admin'
    | '/_root/catalog'
    | '/_root/configuration'
    | '/_root/coverage'
    | '/_root/integrations'
    | '/_root/rca'
    | '/_root/rca-demo'
    | '/github-callback/authenticated'
    | '/github-callback/installed'
    | '/gitlab-callback/authenticated'
    | '/gitlab-callback/installed'
    | '/_root/'
    | '/_root/integrations/aws'
    | '/_root/integrations/gcp'
    | '/_root/getting-started/slack-channels'
    | '/_root/resource/$resourceId'
    | '/(auth)/forgot-password/'
    | '/(auth)/not-verified/'
    | '/(auth)/reset-password-on-invitation/'
    | '/(auth)/reset-password/'
    | '/(auth)/sign-in/'
    | '/(auth)/sign-up/'
    | '/(auth)/slack-not-linked/'
    | '/_root/admin/'
    | '/_root/catalog/'
    | '/_root/configuration/'
    | '/_root/coverage/'
    | '/_root/getting-started/'
    | '/_root/integrations/'
    | '/_root/my-profile/'
    | '/_root/new-project/'
    | '/_root/pull-request/'
    | '/_root/rca-demo/'
    | '/_root/rca/'
    | '/_root/search/'
    | '/_root/integrations/containers/kubernetes'
    | '/_root/integrations/gcp/service-accounts'
    | '/_root/integrations/incidents-management/pagerduty'
    | '/_root/integrations/messaging/slack'
    | '/_root/integrations/monitoring/datadog-api-credentials'
    | '/_root/integrations/monitoring/grafana'
    | '/_root/integrations/terraform-backend/buckets'
    | '/_root/integrations/terraform-backend/hcp-cloud'
    | '/_root/integrations/aws/'
    | '/_root/integrations/gcp/'
    | '/_root/integrations/gitlab/'
    | '/_root/rca-demo/$incidentId/'
    | '/_root/rca/$incidentId/'
    | '/_root/integrations/aws/roles/$roleId'
    | '/_root/integrations/aws/roles/new'
    | '/_root/integrations/aws/users/$userId'
    | '/_root/integrations/aws/users/new'
    | '/_root/integrations/gcp/service-accounts/$accountId'
    | '/_root/integrations/gcp/service-accounts/new'
    | '/_root/integrations/monitoring/datadog-api-credentials/$id'
    | '/_root/integrations/monitoring/datadog-api-credentials/new'
    | '/_root/integrations/monitoring/grafana/$id'
    | '/_root/integrations/monitoring/grafana/new'
    | '/_root/integrations/terraform-backend/hcp-cloud/$tokenId'
    | '/_root/integrations/terraform-backend/hcp-cloud/new'
    | '/_root/integrations/containers/kubernetes/'
    | '/_root/integrations/gcp/service-accounts/'
    | '/_root/integrations/incidents-management/pagerduty/'
    | '/_root/integrations/messaging/slack/'
    | '/_root/integrations/monitoring/datadog-api-credentials/'
    | '/_root/integrations/monitoring/grafana/'
    | '/_root/integrations/terraform-backend/buckets/'
    | '/_root/integrations/terraform-backend/hcp-cloud/'
    | '/_root/integrations/incidents-management/pagerduty/tokens/$tokenId'
    | '/_root/integrations/incidents-management/pagerduty/tokens/new'
    | '/_root/integrations/incidents-management/pagerduty/webhooks/$webhookId'
    | '/_root/integrations/incidents-management/pagerduty/webhooks/new'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  RootRouteRoute: typeof RootRouteRouteWithChildren
  GithubCallbackRouteRoute: typeof GithubCallbackRouteRouteWithChildren
  GitlabCallbackRouteRoute: typeof GitlabCallbackRouteRouteWithChildren
  authForgotPasswordIndexRoute: typeof authForgotPasswordIndexRoute
  authNotVerifiedIndexRoute: typeof authNotVerifiedIndexRoute
  authResetPasswordOnInvitationIndexRoute: typeof authResetPasswordOnInvitationIndexRoute
  authResetPasswordIndexRoute: typeof authResetPasswordIndexRoute
  authSignInIndexRoute: typeof authSignInIndexRoute
  authSignUpIndexRoute: typeof authSignUpIndexRoute
  authSlackNotLinkedIndexRoute: typeof authSlackNotLinkedIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  RootRouteRoute: RootRouteRouteWithChildren,
  GithubCallbackRouteRoute: GithubCallbackRouteRouteWithChildren,
  GitlabCallbackRouteRoute: GitlabCallbackRouteRouteWithChildren,
  authForgotPasswordIndexRoute: authForgotPasswordIndexRoute,
  authNotVerifiedIndexRoute: authNotVerifiedIndexRoute,
  authResetPasswordOnInvitationIndexRoute:
    authResetPasswordOnInvitationIndexRoute,
  authResetPasswordIndexRoute: authResetPasswordIndexRoute,
  authSignInIndexRoute: authSignInIndexRoute,
  authSignUpIndexRoute: authSignUpIndexRoute,
  authSlackNotLinkedIndexRoute: authSlackNotLinkedIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_root",
        "/github-callback",
        "/gitlab-callback",
        "/(auth)/forgot-password/",
        "/(auth)/not-verified/",
        "/(auth)/reset-password-on-invitation/",
        "/(auth)/reset-password/",
        "/(auth)/sign-in/",
        "/(auth)/sign-up/",
        "/(auth)/slack-not-linked/"
      ]
    },
    "/_root": {
      "filePath": "_root/route.tsx",
      "children": [
        "/_root/admin",
        "/_root/catalog",
        "/_root/configuration",
        "/_root/coverage",
        "/_root/integrations",
        "/_root/rca",
        "/_root/rca-demo",
        "/_root/",
        "/_root/getting-started/slack-channels",
        "/_root/resource/$resourceId",
        "/_root/getting-started/",
        "/_root/my-profile/",
        "/_root/new-project/",
        "/_root/pull-request/",
        "/_root/search/"
      ]
    },
    "/github-callback": {
      "filePath": "github-callback/route.tsx",
      "children": [
        "/github-callback/authenticated",
        "/github-callback/installed"
      ]
    },
    "/gitlab-callback": {
      "filePath": "gitlab-callback/route.tsx",
      "children": [
        "/gitlab-callback/authenticated",
        "/gitlab-callback/installed"
      ]
    },
    "/_root/admin": {
      "filePath": "_root/admin/route.tsx",
      "parent": "/_root",
      "children": [
        "/_root/admin/"
      ]
    },
    "/_root/catalog": {
      "filePath": "_root/catalog/route.tsx",
      "parent": "/_root",
      "children": [
        "/_root/catalog/"
      ]
    },
    "/_root/configuration": {
      "filePath": "_root/configuration/route.tsx",
      "parent": "/_root",
      "children": [
        "/_root/configuration/"
      ]
    },
    "/_root/coverage": {
      "filePath": "_root/coverage/route.tsx",
      "parent": "/_root",
      "children": [
        "/_root/coverage/"
      ]
    },
    "/_root/integrations": {
      "filePath": "_root/integrations/route.tsx",
      "parent": "/_root",
      "children": [
        "/_root/integrations/aws",
        "/_root/integrations/gcp",
        "/_root/integrations/",
        "/_root/integrations/containers/kubernetes",
        "/_root/integrations/incidents-management/pagerduty",
        "/_root/integrations/messaging/slack",
        "/_root/integrations/monitoring/datadog-api-credentials",
        "/_root/integrations/monitoring/grafana",
        "/_root/integrations/terraform-backend/buckets",
        "/_root/integrations/terraform-backend/hcp-cloud",
        "/_root/integrations/gitlab/"
      ]
    },
    "/_root/rca": {
      "filePath": "_root/rca/route.tsx",
      "parent": "/_root",
      "children": [
        "/_root/rca/",
        "/_root/rca/$incidentId/"
      ]
    },
    "/_root/rca-demo": {
      "filePath": "_root/rca-demo/route.tsx",
      "parent": "/_root",
      "children": [
        "/_root/rca-demo/",
        "/_root/rca-demo/$incidentId/"
      ]
    },
    "/github-callback/authenticated": {
      "filePath": "github-callback/authenticated.tsx",
      "parent": "/github-callback"
    },
    "/github-callback/installed": {
      "filePath": "github-callback/installed.tsx",
      "parent": "/github-callback"
    },
    "/gitlab-callback/authenticated": {
      "filePath": "gitlab-callback/authenticated.tsx",
      "parent": "/gitlab-callback"
    },
    "/gitlab-callback/installed": {
      "filePath": "gitlab-callback/installed.tsx",
      "parent": "/gitlab-callback"
    },
    "/_root/": {
      "filePath": "_root/index.tsx",
      "parent": "/_root"
    },
    "/_root/integrations/aws": {
      "filePath": "_root/integrations/aws/route.tsx",
      "parent": "/_root/integrations",
      "children": [
        "/_root/integrations/aws/",
        "/_root/integrations/aws/roles/$roleId",
        "/_root/integrations/aws/roles/new",
        "/_root/integrations/aws/users/$userId",
        "/_root/integrations/aws/users/new"
      ]
    },
    "/_root/integrations/gcp": {
      "filePath": "_root/integrations/gcp/route.tsx",
      "parent": "/_root/integrations",
      "children": [
        "/_root/integrations/gcp/service-accounts",
        "/_root/integrations/gcp/"
      ]
    },
    "/_root/getting-started/slack-channels": {
      "filePath": "_root/getting-started/slack-channels.tsx",
      "parent": "/_root"
    },
    "/_root/resource/$resourceId": {
      "filePath": "_root/resource/$resourceId.tsx",
      "parent": "/_root"
    },
    "/(auth)/forgot-password/": {
      "filePath": "(auth)/forgot-password/index.tsx"
    },
    "/(auth)/not-verified/": {
      "filePath": "(auth)/not-verified/index.tsx"
    },
    "/(auth)/reset-password-on-invitation/": {
      "filePath": "(auth)/reset-password-on-invitation/index.tsx"
    },
    "/(auth)/reset-password/": {
      "filePath": "(auth)/reset-password/index.tsx"
    },
    "/(auth)/sign-in/": {
      "filePath": "(auth)/sign-in/index.tsx"
    },
    "/(auth)/sign-up/": {
      "filePath": "(auth)/sign-up/index.tsx"
    },
    "/(auth)/slack-not-linked/": {
      "filePath": "(auth)/slack-not-linked/index.tsx"
    },
    "/_root/admin/": {
      "filePath": "_root/admin/index.tsx",
      "parent": "/_root/admin"
    },
    "/_root/catalog/": {
      "filePath": "_root/catalog/index.tsx",
      "parent": "/_root/catalog"
    },
    "/_root/configuration/": {
      "filePath": "_root/configuration/index.tsx",
      "parent": "/_root/configuration"
    },
    "/_root/coverage/": {
      "filePath": "_root/coverage/index.tsx",
      "parent": "/_root/coverage"
    },
    "/_root/getting-started/": {
      "filePath": "_root/getting-started/index.tsx",
      "parent": "/_root"
    },
    "/_root/integrations/": {
      "filePath": "_root/integrations/index.tsx",
      "parent": "/_root/integrations"
    },
    "/_root/my-profile/": {
      "filePath": "_root/my-profile/index.tsx",
      "parent": "/_root"
    },
    "/_root/new-project/": {
      "filePath": "_root/new-project/index.tsx",
      "parent": "/_root"
    },
    "/_root/pull-request/": {
      "filePath": "_root/pull-request/index.tsx",
      "parent": "/_root"
    },
    "/_root/rca-demo/": {
      "filePath": "_root/rca-demo/index.tsx",
      "parent": "/_root/rca-demo"
    },
    "/_root/rca/": {
      "filePath": "_root/rca/index.tsx",
      "parent": "/_root/rca"
    },
    "/_root/search/": {
      "filePath": "_root/search/index.tsx",
      "parent": "/_root"
    },
    "/_root/integrations/containers/kubernetes": {
      "filePath": "_root/integrations/containers/kubernetes/route.tsx",
      "parent": "/_root/integrations",
      "children": [
        "/_root/integrations/containers/kubernetes/"
      ]
    },
    "/_root/integrations/gcp/service-accounts": {
      "filePath": "_root/integrations/gcp/service-accounts/route.tsx",
      "parent": "/_root/integrations/gcp",
      "children": [
        "/_root/integrations/gcp/service-accounts/$accountId",
        "/_root/integrations/gcp/service-accounts/new",
        "/_root/integrations/gcp/service-accounts/"
      ]
    },
    "/_root/integrations/incidents-management/pagerduty": {
      "filePath": "_root/integrations/incidents-management/pagerduty/route.tsx",
      "parent": "/_root/integrations",
      "children": [
        "/_root/integrations/incidents-management/pagerduty/",
        "/_root/integrations/incidents-management/pagerduty/tokens/$tokenId",
        "/_root/integrations/incidents-management/pagerduty/tokens/new",
        "/_root/integrations/incidents-management/pagerduty/webhooks/$webhookId",
        "/_root/integrations/incidents-management/pagerduty/webhooks/new"
      ]
    },
    "/_root/integrations/messaging/slack": {
      "filePath": "_root/integrations/messaging/slack/route.tsx",
      "parent": "/_root/integrations",
      "children": [
        "/_root/integrations/messaging/slack/"
      ]
    },
    "/_root/integrations/monitoring/datadog-api-credentials": {
      "filePath": "_root/integrations/monitoring/datadog-api-credentials/route.tsx",
      "parent": "/_root/integrations",
      "children": [
        "/_root/integrations/monitoring/datadog-api-credentials/$id",
        "/_root/integrations/monitoring/datadog-api-credentials/new",
        "/_root/integrations/monitoring/datadog-api-credentials/"
      ]
    },
    "/_root/integrations/monitoring/grafana": {
      "filePath": "_root/integrations/monitoring/grafana/route.tsx",
      "parent": "/_root/integrations",
      "children": [
        "/_root/integrations/monitoring/grafana/$id",
        "/_root/integrations/monitoring/grafana/new",
        "/_root/integrations/monitoring/grafana/"
      ]
    },
    "/_root/integrations/terraform-backend/buckets": {
      "filePath": "_root/integrations/terraform-backend/buckets/route.tsx",
      "parent": "/_root/integrations",
      "children": [
        "/_root/integrations/terraform-backend/buckets/"
      ]
    },
    "/_root/integrations/terraform-backend/hcp-cloud": {
      "filePath": "_root/integrations/terraform-backend/hcp-cloud/route.tsx",
      "parent": "/_root/integrations",
      "children": [
        "/_root/integrations/terraform-backend/hcp-cloud/$tokenId",
        "/_root/integrations/terraform-backend/hcp-cloud/new",
        "/_root/integrations/terraform-backend/hcp-cloud/"
      ]
    },
    "/_root/integrations/aws/": {
      "filePath": "_root/integrations/aws/index.tsx",
      "parent": "/_root/integrations/aws"
    },
    "/_root/integrations/gcp/": {
      "filePath": "_root/integrations/gcp/index.tsx",
      "parent": "/_root/integrations/gcp"
    },
    "/_root/integrations/gitlab/": {
      "filePath": "_root/integrations/gitlab/index.tsx",
      "parent": "/_root/integrations"
    },
    "/_root/rca-demo/$incidentId/": {
      "filePath": "_root/rca-demo/$incidentId/index.tsx",
      "parent": "/_root/rca-demo"
    },
    "/_root/rca/$incidentId/": {
      "filePath": "_root/rca/$incidentId/index.tsx",
      "parent": "/_root/rca"
    },
    "/_root/integrations/aws/roles/$roleId": {
      "filePath": "_root/integrations/aws/roles/$roleId.tsx",
      "parent": "/_root/integrations/aws"
    },
    "/_root/integrations/aws/roles/new": {
      "filePath": "_root/integrations/aws/roles/new.tsx",
      "parent": "/_root/integrations/aws"
    },
    "/_root/integrations/aws/users/$userId": {
      "filePath": "_root/integrations/aws/users/$userId.tsx",
      "parent": "/_root/integrations/aws"
    },
    "/_root/integrations/aws/users/new": {
      "filePath": "_root/integrations/aws/users/new.tsx",
      "parent": "/_root/integrations/aws"
    },
    "/_root/integrations/gcp/service-accounts/$accountId": {
      "filePath": "_root/integrations/gcp/service-accounts/$accountId.tsx",
      "parent": "/_root/integrations/gcp/service-accounts"
    },
    "/_root/integrations/gcp/service-accounts/new": {
      "filePath": "_root/integrations/gcp/service-accounts/new.tsx",
      "parent": "/_root/integrations/gcp/service-accounts"
    },
    "/_root/integrations/monitoring/datadog-api-credentials/$id": {
      "filePath": "_root/integrations/monitoring/datadog-api-credentials/$id.tsx",
      "parent": "/_root/integrations/monitoring/datadog-api-credentials"
    },
    "/_root/integrations/monitoring/datadog-api-credentials/new": {
      "filePath": "_root/integrations/monitoring/datadog-api-credentials/new.tsx",
      "parent": "/_root/integrations/monitoring/datadog-api-credentials"
    },
    "/_root/integrations/monitoring/grafana/$id": {
      "filePath": "_root/integrations/monitoring/grafana/$id.tsx",
      "parent": "/_root/integrations/monitoring/grafana"
    },
    "/_root/integrations/monitoring/grafana/new": {
      "filePath": "_root/integrations/monitoring/grafana/new.tsx",
      "parent": "/_root/integrations/monitoring/grafana"
    },
    "/_root/integrations/terraform-backend/hcp-cloud/$tokenId": {
      "filePath": "_root/integrations/terraform-backend/hcp-cloud/$tokenId.tsx",
      "parent": "/_root/integrations/terraform-backend/hcp-cloud"
    },
    "/_root/integrations/terraform-backend/hcp-cloud/new": {
      "filePath": "_root/integrations/terraform-backend/hcp-cloud/new.tsx",
      "parent": "/_root/integrations/terraform-backend/hcp-cloud"
    },
    "/_root/integrations/containers/kubernetes/": {
      "filePath": "_root/integrations/containers/kubernetes/index.tsx",
      "parent": "/_root/integrations/containers/kubernetes"
    },
    "/_root/integrations/gcp/service-accounts/": {
      "filePath": "_root/integrations/gcp/service-accounts/index.tsx",
      "parent": "/_root/integrations/gcp/service-accounts"
    },
    "/_root/integrations/incidents-management/pagerduty/": {
      "filePath": "_root/integrations/incidents-management/pagerduty/index.tsx",
      "parent": "/_root/integrations/incidents-management/pagerduty"
    },
    "/_root/integrations/messaging/slack/": {
      "filePath": "_root/integrations/messaging/slack/index.tsx",
      "parent": "/_root/integrations/messaging/slack"
    },
    "/_root/integrations/monitoring/datadog-api-credentials/": {
      "filePath": "_root/integrations/monitoring/datadog-api-credentials/index.tsx",
      "parent": "/_root/integrations/monitoring/datadog-api-credentials"
    },
    "/_root/integrations/monitoring/grafana/": {
      "filePath": "_root/integrations/monitoring/grafana/index.tsx",
      "parent": "/_root/integrations/monitoring/grafana"
    },
    "/_root/integrations/terraform-backend/buckets/": {
      "filePath": "_root/integrations/terraform-backend/buckets/index.tsx",
      "parent": "/_root/integrations/terraform-backend/buckets"
    },
    "/_root/integrations/terraform-backend/hcp-cloud/": {
      "filePath": "_root/integrations/terraform-backend/hcp-cloud/index.tsx",
      "parent": "/_root/integrations/terraform-backend/hcp-cloud"
    },
    "/_root/integrations/incidents-management/pagerduty/tokens/$tokenId": {
      "filePath": "_root/integrations/incidents-management/pagerduty/tokens/$tokenId.tsx",
      "parent": "/_root/integrations/incidents-management/pagerduty"
    },
    "/_root/integrations/incidents-management/pagerduty/tokens/new": {
      "filePath": "_root/integrations/incidents-management/pagerduty/tokens/new.tsx",
      "parent": "/_root/integrations/incidents-management/pagerduty"
    },
    "/_root/integrations/incidents-management/pagerduty/webhooks/$webhookId": {
      "filePath": "_root/integrations/incidents-management/pagerduty/webhooks/$webhookId.tsx",
      "parent": "/_root/integrations/incidents-management/pagerduty"
    },
    "/_root/integrations/incidents-management/pagerduty/webhooks/new": {
      "filePath": "_root/integrations/incidents-management/pagerduty/webhooks/new.tsx",
      "parent": "/_root/integrations/incidents-management/pagerduty"
    }
  }
}
ROUTE_MANIFEST_END */
